// Auto-generated filled dot grid from dotted-map (Natural Earth data, public domain)
// ViewBox 0 0 1000 500, 4689 dots filling land areas
export const WORLD_MAP_DOTS: [number, number][] = [
  [25.6,0],
  [32.1,0],
  [147.4,0],
  [153.8,0],
  [160.3,0],
  [166.7,0],
  [173.1,0],
  [179.5,0],
  [211.5,0],
  [217.9,0],
  [237.2,0],
  [243.6,0],
  [250,0],
  [256.4,0],
  [262.8,0],
  [269.2,0],
  [275.6,0],
  [282.1,0],
  [346.2,0],
  [352.6,0],
  [359,0],
  [365.4,0],
  [371.8,0],
  [378.2,0],
  [384.6,0],
  [391,0],
  [397.4,0],
  [403.8,0],
  [410.3,0],
  [416.7,0],
  [423.1,0],
  [429.5,0],
  [576.9,0],
  [583.3,0],
  [666.7,0],
  [705.1,0],
  [711.5,0],
  [717.9,0],
  [724.4,0],
  [730.8,0],
  [737.2,0],
  [743.6,0],
  [750,0],
  [756.4,0],
  [762.8,0],
  [769.2,0],
  [775.6,0],
  [782.1,0],
  [788.5,0],
  [794.9,0],
  [801.3,0],
  [807.7,0],
  [814.1,0],
  [820.5,0],
  [826.9,0],
  [833.3,0],
  [839.7,0],
  [846.2,0],
  [852.6,0],
  [859,0],
  [865.4,0],
  [871.8,0],
  [878.2,0],
  [884.6,0],
  [891,0],
  [897.4,0],
  [903.8,0],
  [910.3,0],
  [916.7,0],
  [923.1,0],
  [929.5,0],
  [935.9,0],
  [942.3,0],
  [948.7,0],
  [955.1,0],
  [974.4,0],
  [12.8,6.3],
  [19.2,6.3],
  [25.6,6.3],
  [32.1,6.3],
  [38.5,6.3],
  [44.9,6.3],
  [51.3,6.3],
  [115.4,6.3],
  [160.3,6.3],
  [166.7,6.3],
  [173.1,6.3],
  [179.5,6.3],
  [185.9,6.3],
  [192.3,6.3],
  [211.5,6.3],
  [217.9,6.3],
  [237.2,6.3],
  [243.6,6.3],
  [250,6.3],
  [256.4,6.3],
  [262.8,6.3],
  [269.2,6.3],
  [275.6,6.3],
  [282.1,6.3],
  [288.5,6.3],
  [339.7,6.3],
  [346.2,6.3],
  [352.6,6.3],
  [359,6.3],
  [365.4,6.3],
  [371.8,6.3],
  [378.2,6.3],
  [384.6,6.3],
  [391,6.3],
  [397.4,6.3],
  [403.8,6.3],
  [410.3,6.3],
  [416.7,6.3],
  [570.5,6.3],
  [576.9,6.3],
  [583.3,6.3],
  [589.7,6.3],
  [705.1,6.3],
  [711.5,6.3],
  [717.9,6.3],
  [724.4,6.3],
  [730.8,6.3],
  [737.2,6.3],
  [743.6,6.3],
  [750,6.3],
  [756.4,6.3],
  [762.8,6.3],
  [769.2,6.3],
  [775.6,6.3],
  [782.1,6.3],
  [788.5,6.3],
  [794.9,6.3],
  [801.3,6.3],
  [807.7,6.3],
  [814.1,6.3],
  [820.5,6.3],
  [826.9,6.3],
  [833.3,6.3],
  [839.7,6.3],
  [846.2,6.3],
  [852.6,6.3],
  [859,6.3],
  [865.4,6.3],
  [871.8,6.3],
  [878.2,6.3],
  [884.6,6.3],
  [891,6.3],
  [897.4,6.3],
  [903.8,6.3],
  [910.3,6.3],
  [916.7,6.3],
  [923.1,6.3],
  [929.5,6.3],
  [935.9,6.3],
  [942.3,6.3],
  [948.7,6.3],
  [955.1,6.3],
  [961.5,6.3],
  [967.9,6.3],
  [974.4,6.3],
  [980.8,6.3],
  [12.8,12.7],
  [19.2,12.7],
  [25.6,12.7],
  [32.1,12.7],
  [38.5,12.7],
  [44.9,12.7],
  [51.3,12.7],
  [57.7,12.7],
  [64.1,12.7],
  [70.5,12.7],
  [76.9,12.7],
  [96.2,12.7],
  [102.6,12.7],
  [109,12.7],
  [115.4,12.7],
  [121.8,12.7],
  [134.6,12.7],
  [153.8,12.7],
  [160.3,12.7],
  [166.7,12.7],
  [173.1,12.7],
  [179.5,12.7],
  [185.9,12.7],
  [192.3,12.7],
  [205.1,12.7],
  [217.9,12.7],
  [224.4,12.7],
  [243.6,12.7],
  [250,12.7],
  [269.2,12.7],
  [275.6,12.7],
  [282.1,12.7],
  [288.5,12.7],
  [294.9,12.7],
  [339.7,12.7],
  [352.6,12.7],
  [359,12.7],
  [365.4,12.7],
  [371.8,12.7],
  [378.2,12.7],
  [384.6,12.7],
  [391,12.7],
  [397.4,12.7],
  [403.8,12.7],
  [410.3,12.7],
  [416.7,12.7],
  [423.1,12.7],
  [557.7,12.7],
  [564.1,12.7],
  [570.5,12.7],
  [576.9,12.7],
  [583.3,12.7],
  [589.7,12.7],
  [596.2,12.7],
  [685.9,12.7],
  [705.1,12.7],
  [711.5,12.7],
  [717.9,12.7],
  [724.4,12.7],
  [730.8,12.7],
  [737.2,12.7],
  [743.6,12.7],
  [750,12.7],
  [756.4,12.7],
  [762.8,12.7],
  [769.2,12.7],
  [775.6,12.7],
  [782.1,12.7],
  [788.5,12.7],
  [794.9,12.7],
  [801.3,12.7],
  [807.7,12.7],
  [814.1,12.7],
  [820.5,12.7],
  [826.9,12.7],
  [833.3,12.7],
  [839.7,12.7],
  [846.2,12.7],
  [852.6,12.7],
  [859,12.7],
  [865.4,12.7],
  [871.8,12.7],
  [878.2,12.7],
  [884.6,12.7],
  [891,12.7],
  [897.4,12.7],
  [903.8,12.7],
  [910.3,12.7],
  [916.7,12.7],
  [923.1,12.7],
  [929.5,12.7],
  [935.9,12.7],
  [942.3,12.7],
  [948.7,12.7],
  [955.1,12.7],
  [961.5,12.7],
  [967.9,12.7],
  [974.4,12.7],
  [980.8,12.7],
  [993.6,12.7],
  [0,19],
  [6.4,19],
  [12.8,19],
  [19.2,19],
  [25.6,19],
  [32.1,19],
  [38.5,19],
  [44.9,19],
  [51.3,19],
  [57.7,19],
  [64.1,19],
  [70.5,19],
  [76.9,19],
  [83.3,19],
  [89.7,19],
  [96.2,19],
  [102.6,19],
  [109,19],
  [115.4,19],
  [121.8,19],
  [128.2,19],
  [134.6,19],
  [141,19],
  [147.4,19],
  [160.3,19],
  [166.7,19],
  [217.9,19],
  [224.4,19],
  [230.8,19],
  [243.6,19],
  [250,19],
  [275.6,19],
  [282.1,19],
  [288.5,19],
  [346.2,19],
  [352.6,19],
  [359,19],
  [365.4,19],
  [371.8,19],
  [378.2,19],
  [384.6,19],
  [391,19],
  [397.4,19],
  [403.8,19],
  [410.3,19],
  [416.7,19],
  [551.3,19],
  [557.7,19],
  [564.1,19],
  [570.5,19],
  [576.9,19],
  [583.3,19],
  [589.7,19],
  [596.2,19],
  [602.6,19],
  [609,19],
  [685.9,19],
  [692.3,19],
  [698.7,19],
  [711.5,19],
  [717.9,19],
  [730.8,19],
  [737.2,19],
  [743.6,19],
  [750,19],
  [756.4,19],
  [762.8,19],
  [769.2,19],
  [775.6,19],
  [782.1,19],
  [788.5,19],
  [794.9,19],
  [801.3,19],
  [807.7,19],
  [814.1,19],
  [820.5,19],
  [826.9,19],
  [833.3,19],
  [839.7,19],
  [846.2,19],
  [852.6,19],
  [859,19],
  [865.4,19],
  [871.8,19],
  [878.2,19],
  [884.6,19],
  [891,19],
  [897.4,19],
  [903.8,19],
  [910.3,19],
  [916.7,19],
  [923.1,19],
  [929.5,19],
  [935.9,19],
  [942.3,19],
  [948.7,19],
  [955.1,19],
  [961.5,19],
  [967.9,19],
  [974.4,19],
  [980.8,19],
  [987.2,19],
  [993.6,19],
  [1000,19],
  [6.4,25.3],
  [12.8,25.3],
  [19.2,25.3],
  [25.6,25.3],
  [32.1,25.3],
  [38.5,25.3],
  [44.9,25.3],
  [51.3,25.3],
  [57.7,25.3],
  [64.1,25.3],
  [70.5,25.3],
  [76.9,25.3],
  [83.3,25.3],
  [89.7,25.3],
  [96.2,25.3],
  [102.6,25.3],
  [109,25.3],
  [115.4,25.3],
  [121.8,25.3],
  [128.2,25.3],
  [134.6,25.3],
  [141,25.3],
  [147.4,25.3],
  [179.5,25.3],
  [205.1,25.3],
  [217.9,25.3],
  [224.4,25.3],
  [230.8,25.3],
  [243.6,25.3],
  [250,25.3],
  [269.2,25.3],
  [282.1,25.3],
  [288.5,25.3],
  [294.9,25.3],
  [339.7,25.3],
  [346.2,25.3],
  [352.6,25.3],
  [359,25.3],
  [365.4,25.3],
  [371.8,25.3],
  [378.2,25.3],
  [384.6,25.3],
  [391,25.3],
  [397.4,25.3],
  [551.3,25.3],
  [557.7,25.3],
  [564.1,25.3],
  [570.5,25.3],
  [576.9,25.3],
  [583.3,25.3],
  [589.7,25.3],
  [596.2,25.3],
  [602.6,25.3],
  [609,25.3],
  [615.4,25.3],
  [634.6,25.3],
  [653.8,25.3],
  [660.3,25.3],
  [666.7,25.3],
  [673.1,25.3],
  [679.5,25.3],
  [685.9,25.3],
  [692.3,25.3],
  [698.7,25.3],
  [705.1,25.3],
  [711.5,25.3],
  [717.9,25.3],
  [730.8,25.3],
  [737.2,25.3],
  [743.6,25.3],
  [750,25.3],
  [756.4,25.3],
  [762.8,25.3],
  [769.2,25.3],
  [775.6,25.3],
  [782.1,25.3],
  [788.5,25.3],
  [794.9,25.3],
  [801.3,25.3],
  [807.7,25.3],
  [814.1,25.3],
  [820.5,25.3],
  [826.9,25.3],
  [833.3,25.3],
  [839.7,25.3],
  [846.2,25.3],
  [852.6,25.3],
  [859,25.3],
  [865.4,25.3],
  [871.8,25.3],
  [878.2,25.3],
  [884.6,25.3],
  [891,25.3],
  [897.4,25.3],
  [903.8,25.3],
  [910.3,25.3],
  [916.7,25.3],
  [923.1,25.3],
  [929.5,25.3],
  [935.9,25.3],
  [942.3,25.3],
  [948.7,25.3],
  [955.1,25.3],
  [961.5,25.3],
  [967.9,25.3],
  [974.4,25.3],
  [980.8,25.3],
  [987.2,25.3],
  [993.6,25.3],
  [1000,25.3],
  [6.4,31.6],
  [12.8,31.6],
  [19.2,31.6],
  [25.6,31.6],
  [32.1,31.6],
  [38.5,31.6],
  [44.9,31.6],
  [51.3,31.6],
  [57.7,31.6],
  [64.1,31.6],
  [70.5,31.6],
  [76.9,31.6],
  [83.3,31.6],
  [89.7,31.6],
  [96.2,31.6],
  [102.6,31.6],
  [109,31.6],
  [115.4,31.6],
  [121.8,31.6],
  [128.2,31.6],
  [134.6,31.6],
  [141,31.6],
  [147.4,31.6],
  [153.8,31.6],
  [160.3,31.6],
  [166.7,31.6],
  [173.1,31.6],
  [179.5,31.6],
  [185.9,31.6],
  [192.3,31.6],
  [198.7,31.6],
  [205.1,31.6],
  [211.5,31.6],
  [217.9,31.6],
  [224.4,31.6],
  [230.8,31.6],
  [237.2,31.6],
  [243.6,31.6],
  [250,31.6],
  [269.2,31.6],
  [282.1,31.6],
  [288.5,31.6],
  [294.9,31.6],
  [301.3,31.6],
  [339.7,31.6],
  [346.2,31.6],
  [352.6,31.6],
  [359,31.6],
  [365.4,31.6],
  [371.8,31.6],
  [378.2,31.6],
  [384.6,31.6],
  [391,31.6],
  [397.4,31.6],
  [544.9,31.6],
  [551.3,31.6],
  [557.7,31.6],
  [564.1,31.6],
  [570.5,31.6],
  [576.9,31.6],
  [583.3,31.6],
  [589.7,31.6],
  [596.2,31.6],
  [602.6,31.6],
  [609,31.6],
  [615.4,31.6],
  [621.8,31.6],
  [634.6,31.6],
  [647.4,31.6],
  [653.8,31.6],
  [660.3,31.6],
  [666.7,31.6],
  [673.1,31.6],
  [679.5,31.6],
  [685.9,31.6],
  [692.3,31.6],
  [698.7,31.6],
  [705.1,31.6],
  [711.5,31.6],
  [717.9,31.6],
  [724.4,31.6],
  [730.8,31.6],
  [737.2,31.6],
  [743.6,31.6],
  [750,31.6],
  [756.4,31.6],
  [762.8,31.6],
  [769.2,31.6],
  [775.6,31.6],
  [782.1,31.6],
  [788.5,31.6],
  [794.9,31.6],
  [801.3,31.6],
  [807.7,31.6],
  [814.1,31.6],
  [820.5,31.6],
  [826.9,31.6],
  [833.3,31.6],
  [839.7,31.6],
  [846.2,31.6],
  [852.6,31.6],
  [859,31.6],
  [865.4,31.6],
  [871.8,31.6],
  [878.2,31.6],
  [884.6,31.6],
  [891,31.6],
  [897.4,31.6],
  [903.8,31.6],
  [910.3,31.6],
  [916.7,31.6],
  [923.1,31.6],
  [929.5,31.6],
  [935.9,31.6],
  [942.3,31.6],
  [948.7,31.6],
  [955.1,31.6],
  [961.5,31.6],
  [967.9,31.6],
  [974.4,31.6],
  [980.8,31.6],
  [987.2,31.6],
  [993.6,31.6],
  [1000,31.6],
  [6.4,38],
  [12.8,38],
  [19.2,38],
  [25.6,38],
  [32.1,38],
  [38.5,38],
  [44.9,38],
  [51.3,38],
  [57.7,38],
  [64.1,38],
  [70.5,38],
  [76.9,38],
  [83.3,38],
  [89.7,38],
  [96.2,38],
  [102.6,38],
  [109,38],
  [115.4,38],
  [121.8,38],
  [128.2,38],
  [134.6,38],
  [141,38],
  [147.4,38],
  [153.8,38],
  [160.3,38],
  [166.7,38],
  [173.1,38],
  [179.5,38],
  [185.9,38],
  [192.3,38],
  [198.7,38],
  [205.1,38],
  [211.5,38],
  [217.9,38],
  [224.4,38],
  [230.8,38],
  [237.2,38],
  [243.6,38],
  [282.1,38],
  [288.5,38],
  [294.9,38],
  [301.3,38],
  [307.7,38],
  [339.7,38],
  [346.2,38],
  [352.6,38],
  [359,38],
  [365.4,38],
  [371.8,38],
  [378.2,38],
  [384.6,38],
  [391,38],
  [455.1,38],
  [544.9,38],
  [551.3,38],
  [557.7,38],
  [564.1,38],
  [570.5,38],
  [576.9,38],
  [583.3,38],
  [589.7,38],
  [596.2,38],
  [609,38],
  [615.4,38],
  [628.2,38],
  [634.6,38],
  [641,38],
  [647.4,38],
  [653.8,38],
  [660.3,38],
  [666.7,38],
  [673.1,38],
  [679.5,38],
  [685.9,38],
  [692.3,38],
  [698.7,38],
  [705.1,38],
  [711.5,38],
  [724.4,38],
  [730.8,38],
  [737.2,38],
  [743.6,38],
  [750,38],
  [756.4,38],
  [762.8,38],
  [769.2,38],
  [775.6,38],
  [782.1,38],
  [788.5,38],
  [794.9,38],
  [801.3,38],
  [807.7,38],
  [814.1,38],
  [820.5,38],
  [826.9,38],
  [833.3,38],
  [839.7,38],
  [846.2,38],
  [852.6,38],
  [859,38],
  [865.4,38],
  [871.8,38],
  [878.2,38],
  [884.6,38],
  [891,38],
  [897.4,38],
  [903.8,38],
  [910.3,38],
  [916.7,38],
  [923.1,38],
  [929.5,38],
  [935.9,38],
  [942.3,38],
  [948.7,38],
  [955.1,38],
  [961.5,38],
  [967.9,38],
  [974.4,38],
  [980.8,38],
  [987.2,38],
  [993.6,38],
  [1000,38],
  [0,44.3],
  [6.4,44.3],
  [12.8,44.3],
  [19.2,44.3],
  [25.6,44.3],
  [32.1,44.3],
  [38.5,44.3],
  [44.9,44.3],
  [51.3,44.3],
  [57.7,44.3],
  [64.1,44.3],
  [70.5,44.3],
  [76.9,44.3],
  [83.3,44.3],
  [89.7,44.3],
  [96.2,44.3],
  [102.6,44.3],
  [109,44.3],
  [115.4,44.3],
  [121.8,44.3],
  [128.2,44.3],
  [134.6,44.3],
  [141,44.3],
  [147.4,44.3],
  [153.8,44.3],
  [160.3,44.3],
  [166.7,44.3],
  [173.1,44.3],
  [179.5,44.3],
  [185.9,44.3],
  [192.3,44.3],
  [198.7,44.3],
  [205.1,44.3],
  [211.5,44.3],
  [217.9,44.3],
  [224.4,44.3],
  [230.8,44.3],
  [237.2,44.3],
  [282.1,44.3],
  [288.5,44.3],
  [294.9,44.3],
  [307.7,44.3],
  [346.2,44.3],
  [352.6,44.3],
  [359,44.3],
  [365.4,44.3],
  [371.8,44.3],
  [378.2,44.3],
  [429.5,44.3],
  [435.9,44.3],
  [442.3,44.3],
  [448.7,44.3],
  [455.1,44.3],
  [538.5,44.3],
  [544.9,44.3],
  [551.3,44.3],
  [557.7,44.3],
  [564.1,44.3],
  [576.9,44.3],
  [583.3,44.3],
  [589.7,44.3],
  [596.2,44.3],
  [602.6,44.3],
  [621.8,44.3],
  [628.2,44.3],
  [634.6,44.3],
  [641,44.3],
  [647.4,44.3],
  [653.8,44.3],
  [660.3,44.3],
  [666.7,44.3],
  [673.1,44.3],
  [679.5,44.3],
  [685.9,44.3],
  [692.3,44.3],
  [698.7,44.3],
  [705.1,44.3],
  [711.5,44.3],
  [717.9,44.3],
  [724.4,44.3],
  [730.8,44.3],
  [737.2,44.3],
  [743.6,44.3],
  [750,44.3],
  [756.4,44.3],
  [762.8,44.3],
  [769.2,44.3],
  [775.6,44.3],
  [782.1,44.3],
  [788.5,44.3],
  [794.9,44.3],
  [801.3,44.3],
  [807.7,44.3],
  [814.1,44.3],
  [820.5,44.3],
  [826.9,44.3],
  [833.3,44.3],
  [839.7,44.3],
  [846.2,44.3],
  [852.6,44.3],
  [859,44.3],
  [865.4,44.3],
  [871.8,44.3],
  [878.2,44.3],
  [884.6,44.3],
  [891,44.3],
  [897.4,44.3],
  [903.8,44.3],
  [910.3,44.3],
  [916.7,44.3],
  [923.1,44.3],
  [929.5,44.3],
  [935.9,44.3],
  [942.3,44.3],
  [948.7,44.3],
  [955.1,44.3],
  [961.5,44.3],
  [967.9,44.3],
  [974.4,44.3],
  [980.8,44.3],
  [987.2,44.3],
  [993.6,44.3],
  [1000,44.3],
  [0,50.6],
  [6.4,50.6],
  [19.2,50.6],
  [25.6,50.6],
  [32.1,50.6],
  [38.5,50.6],
  [44.9,50.6],
  [51.3,50.6],
  [57.7,50.6],
  [64.1,50.6],
  [70.5,50.6],
  [76.9,50.6],
  [83.3,50.6],
  [89.7,50.6],
  [96.2,50.6],
  [102.6,50.6],
  [109,50.6],
  [115.4,50.6],
  [121.8,50.6],
  [128.2,50.6],
  [134.6,50.6],
  [141,50.6],
  [147.4,50.6],
  [153.8,50.6],
  [160.3,50.6],
  [166.7,50.6],
  [173.1,50.6],
  [179.5,50.6],
  [185.9,50.6],
  [192.3,50.6],
  [198.7,50.6],
  [205.1,50.6],
  [211.5,50.6],
  [217.9,50.6],
  [224.4,50.6],
  [230.8,50.6],
  [243.6,50.6],
  [250,50.6],
  [269.2,50.6],
  [275.6,50.6],
  [282.1,50.6],
  [288.5,50.6],
  [294.9,50.6],
  [301.3,50.6],
  [346.2,50.6],
  [352.6,50.6],
  [359,50.6],
  [365.4,50.6],
  [371.8,50.6],
  [435.9,50.6],
  [442.3,50.6],
  [448.7,50.6],
  [455.1,50.6],
  [538.5,50.6],
  [544.9,50.6],
  [551.3,50.6],
  [557.7,50.6],
  [564.1,50.6],
  [576.9,50.6],
  [583.3,50.6],
  [589.7,50.6],
  [596.2,50.6],
  [602.6,50.6],
  [615.4,50.6],
  [621.8,50.6],
  [628.2,50.6],
  [634.6,50.6],
  [641,50.6],
  [647.4,50.6],
  [653.8,50.6],
  [660.3,50.6],
  [666.7,50.6],
  [673.1,50.6],
  [679.5,50.6],
  [685.9,50.6],
  [692.3,50.6],
  [698.7,50.6],
  [705.1,50.6],
  [711.5,50.6],
  [717.9,50.6],
  [724.4,50.6],
  [730.8,50.6],
  [737.2,50.6],
  [743.6,50.6],
  [750,50.6],
  [756.4,50.6],
  [762.8,50.6],
  [769.2,50.6],
  [775.6,50.6],
  [782.1,50.6],
  [788.5,50.6],
  [794.9,50.6],
  [801.3,50.6],
  [807.7,50.6],
  [814.1,50.6],
  [820.5,50.6],
  [826.9,50.6],
  [833.3,50.6],
  [839.7,50.6],
  [846.2,50.6],
  [852.6,50.6],
  [859,50.6],
  [865.4,50.6],
  [871.8,50.6],
  [878.2,50.6],
  [884.6,50.6],
  [891,50.6],
  [897.4,50.6],
  [903.8,50.6],
  [910.3,50.6],
  [916.7,50.6],
  [923.1,50.6],
  [929.5,50.6],
  [935.9,50.6],
  [942.3,50.6],
  [948.7,50.6],
  [955.1,50.6],
  [961.5,50.6],
  [967.9,50.6],
  [974.4,50.6],
  [980.8,50.6],
  [987.2,50.6],
  [993.6,50.6],
  [1000,50.6],
  [19.2,57],
  [25.6,57],
  [32.1,57],
  [38.5,57],
  [44.9,57],
  [51.3,57],
  [57.7,57],
  [64.1,57],
  [70.5,57],
  [76.9,57],
  [83.3,57],
  [89.7,57],
  [96.2,57],
  [102.6,57],
  [109,57],
  [115.4,57],
  [121.8,57],
  [128.2,57],
  [134.6,57],
  [141,57],
  [147.4,57],
  [153.8,57],
  [160.3,57],
  [166.7,57],
  [173.1,57],
  [179.5,57],
  [185.9,57],
  [192.3,57],
  [198.7,57],
  [205.1,57],
  [211.5,57],
  [217.9,57],
  [224.4,57],
  [243.6,57],
  [256.4,57],
  [288.5,57],
  [294.9,57],
  [301.3,57],
  [346.2,57],
  [352.6,57],
  [359,57],
  [365.4,57],
  [371.8,57],
  [442.3,57],
  [532.1,57],
  [538.5,57],
  [544.9,57],
  [551.3,57],
  [557.7,57],
  [570.5,57],
  [576.9,57],
  [583.3,57],
  [589.7,57],
  [596.2,57],
  [602.6,57],
  [609,57],
  [615.4,57],
  [621.8,57],
  [628.2,57],
  [634.6,57],
  [641,57],
  [647.4,57],
  [653.8,57],
  [660.3,57],
  [666.7,57],
  [673.1,57],
  [679.5,57],
  [685.9,57],
  [692.3,57],
  [698.7,57],
  [705.1,57],
  [711.5,57],
  [717.9,57],
  [724.4,57],
  [730.8,57],
  [737.2,57],
  [743.6,57],
  [750,57],
  [756.4,57],
  [762.8,57],
  [769.2,57],
  [775.6,57],
  [782.1,57],
  [788.5,57],
  [794.9,57],
  [801.3,57],
  [807.7,57],
  [814.1,57],
  [820.5,57],
  [826.9,57],
  [833.3,57],
  [839.7,57],
  [846.2,57],
  [852.6,57],
  [859,57],
  [865.4,57],
  [871.8,57],
  [878.2,57],
  [884.6,57],
  [891,57],
  [897.4,57],
  [903.8,57],
  [910.3,57],
  [916.7,57],
  [923.1,57],
  [929.5,57],
  [935.9,57],
  [942.3,57],
  [948.7,57],
  [955.1,57],
  [961.5,57],
  [967.9,57],
  [974.4,57],
  [980.8,57],
  [987.2,57],
  [993.6,57],
  [1000,57],
  [6.4,63.3],
  [12.8,63.3],
  [19.2,63.3],
  [25.6,63.3],
  [32.1,63.3],
  [38.5,63.3],
  [44.9,63.3],
  [51.3,63.3],
  [57.7,63.3],
  [64.1,63.3],
  [70.5,63.3],
  [76.9,63.3],
  [83.3,63.3],
  [89.7,63.3],
  [96.2,63.3],
  [102.6,63.3],
  [109,63.3],
  [115.4,63.3],
  [121.8,63.3],
  [128.2,63.3],
  [134.6,63.3],
  [141,63.3],
  [147.4,63.3],
  [153.8,63.3],
  [160.3,63.3],
  [166.7,63.3],
  [173.1,63.3],
  [179.5,63.3],
  [185.9,63.3],
  [192.3,63.3],
  [198.7,63.3],
  [205.1,63.3],
  [211.5,63.3],
  [217.9,63.3],
  [250,63.3],
  [288.5,63.3],
  [294.9,63.3],
  [352.6,63.3],
  [359,63.3],
  [365.4,63.3],
  [519.2,63.3],
  [525.6,63.3],
  [532.1,63.3],
  [538.5,63.3],
  [544.9,63.3],
  [551.3,63.3],
  [564.1,63.3],
  [570.5,63.3],
  [576.9,63.3],
  [583.3,63.3],
  [589.7,63.3],
  [596.2,63.3],
  [602.6,63.3],
  [609,63.3],
  [615.4,63.3],
  [621.8,63.3],
  [628.2,63.3],
  [634.6,63.3],
  [641,63.3],
  [647.4,63.3],
  [653.8,63.3],
  [660.3,63.3],
  [666.7,63.3],
  [673.1,63.3],
  [679.5,63.3],
  [685.9,63.3],
  [692.3,63.3],
  [698.7,63.3],
  [705.1,63.3],
  [711.5,63.3],
  [717.9,63.3],
  [724.4,63.3],
  [730.8,63.3],
  [737.2,63.3],
  [743.6,63.3],
  [750,63.3],
  [756.4,63.3],
  [762.8,63.3],
  [769.2,63.3],
  [775.6,63.3],
  [782.1,63.3],
  [788.5,63.3],
  [794.9,63.3],
  [801.3,63.3],
  [807.7,63.3],
  [814.1,63.3],
  [820.5,63.3],
  [826.9,63.3],
  [833.3,63.3],
  [839.7,63.3],
  [846.2,63.3],
  [852.6,63.3],
  [859,63.3],
  [865.4,63.3],
  [871.8,63.3],
  [878.2,63.3],
  [884.6,63.3],
  [891,63.3],
  [897.4,63.3],
  [903.8,63.3],
  [910.3,63.3],
  [916.7,63.3],
  [923.1,63.3],
  [929.5,63.3],
  [935.9,63.3],
  [942.3,63.3],
  [948.7,63.3],
  [955.1,63.3],
  [961.5,63.3],
  [967.9,63.3],
  [974.4,63.3],
  [980.8,63.3],
  [987.2,63.3],
  [993.6,63.3],
  [1000,63.3],
  [0,69.6],
  [6.4,69.6],
  [12.8,69.6],
  [19.2,69.6],
  [25.6,69.6],
  [32.1,69.6],
  [38.5,69.6],
  [44.9,69.6],
  [51.3,69.6],
  [57.7,69.6],
  [64.1,69.6],
  [70.5,69.6],
  [76.9,69.6],
  [83.3,69.6],
  [89.7,69.6],
  [96.2,69.6],
  [102.6,69.6],
  [109,69.6],
  [115.4,69.6],
  [121.8,69.6],
  [128.2,69.6],
  [134.6,69.6],
  [141,69.6],
  [147.4,69.6],
  [153.8,69.6],
  [160.3,69.6],
  [166.7,69.6],
  [173.1,69.6],
  [179.5,69.6],
  [185.9,69.6],
  [192.3,69.6],
  [198.7,69.6],
  [205.1,69.6],
  [211.5,69.6],
  [217.9,69.6],
  [269.2,69.6],
  [275.6,69.6],
  [282.1,69.6],
  [352.6,69.6],
  [359,69.6],
  [365.4,69.6],
  [371.8,69.6],
  [519.2,69.6],
  [525.6,69.6],
  [532.1,69.6],
  [538.5,69.6],
  [544.9,69.6],
  [551.3,69.6],
  [570.5,69.6],
  [576.9,69.6],
  [583.3,69.6],
  [589.7,69.6],
  [596.2,69.6],
  [602.6,69.6],
  [609,69.6],
  [615.4,69.6],
  [621.8,69.6],
  [628.2,69.6],
  [634.6,69.6],
  [641,69.6],
  [647.4,69.6],
  [653.8,69.6],
  [660.3,69.6],
  [666.7,69.6],
  [673.1,69.6],
  [679.5,69.6],
  [685.9,69.6],
  [692.3,69.6],
  [698.7,69.6],
  [705.1,69.6],
  [711.5,69.6],
  [717.9,69.6],
  [724.4,69.6],
  [730.8,69.6],
  [737.2,69.6],
  [743.6,69.6],
  [750,69.6],
  [756.4,69.6],
  [762.8,69.6],
  [769.2,69.6],
  [775.6,69.6],
  [782.1,69.6],
  [788.5,69.6],
  [794.9,69.6],
  [801.3,69.6],
  [807.7,69.6],
  [814.1,69.6],
  [820.5,69.6],
  [826.9,69.6],
  [833.3,69.6],
  [839.7,69.6],
  [846.2,69.6],
  [852.6,69.6],
  [859,69.6],
  [865.4,69.6],
  [871.8,69.6],
  [878.2,69.6],
  [884.6,69.6],
  [891,69.6],
  [897.4,69.6],
  [903.8,69.6],
  [910.3,69.6],
  [916.7,69.6],
  [923.1,69.6],
  [929.5,69.6],
  [935.9,69.6],
  [942.3,69.6],
  [948.7,69.6],
  [955.1,69.6],
  [961.5,69.6],
  [967.9,69.6],
  [974.4,69.6],
  [980.8,69.6],
  [987.2,69.6],
  [1000,69.6],
  [6.4,75.9],
  [12.8,75.9],
  [19.2,75.9],
  [25.6,75.9],
  [32.1,75.9],
  [38.5,75.9],
  [44.9,75.9],
  [51.3,75.9],
  [64.1,75.9],
  [70.5,75.9],
  [76.9,75.9],
  [83.3,75.9],
  [89.7,75.9],
  [96.2,75.9],
  [102.6,75.9],
  [109,75.9],
  [115.4,75.9],
  [121.8,75.9],
  [128.2,75.9],
  [134.6,75.9],
  [141,75.9],
  [147.4,75.9],
  [153.8,75.9],
  [160.3,75.9],
  [166.7,75.9],
  [173.1,75.9],
  [179.5,75.9],
  [185.9,75.9],
  [192.3,75.9],
  [198.7,75.9],
  [205.1,75.9],
  [211.5,75.9],
  [269.2,75.9],
  [275.6,75.9],
  [282.1,75.9],
  [288.5,75.9],
  [365.4,75.9],
  [519.2,75.9],
  [525.6,75.9],
  [532.1,75.9],
  [538.5,75.9],
  [544.9,75.9],
  [551.3,75.9],
  [570.5,75.9],
  [576.9,75.9],
  [583.3,75.9],
  [589.7,75.9],
  [596.2,75.9],
  [602.6,75.9],
  [609,75.9],
  [615.4,75.9],
  [621.8,75.9],
  [628.2,75.9],
  [634.6,75.9],
  [641,75.9],
  [647.4,75.9],
  [653.8,75.9],
  [660.3,75.9],
  [666.7,75.9],
  [673.1,75.9],
  [679.5,75.9],
  [685.9,75.9],
  [692.3,75.9],
  [698.7,75.9],
  [705.1,75.9],
  [711.5,75.9],
  [717.9,75.9],
  [724.4,75.9],
  [730.8,75.9],
  [737.2,75.9],
  [743.6,75.9],
  [750,75.9],
  [756.4,75.9],
  [762.8,75.9],
  [769.2,75.9],
  [775.6,75.9],
  [782.1,75.9],
  [788.5,75.9],
  [794.9,75.9],
  [801.3,75.9],
  [807.7,75.9],
  [814.1,75.9],
  [820.5,75.9],
  [826.9,75.9],
  [833.3,75.9],
  [839.7,75.9],
  [846.2,75.9],
  [852.6,75.9],
  [859,75.9],
  [865.4,75.9],
  [871.8,75.9],
  [878.2,75.9],
  [884.6,75.9],
  [891,75.9],
  [897.4,75.9],
  [903.8,75.9],
  [910.3,75.9],
  [916.7,75.9],
  [923.1,75.9],
  [929.5,75.9],
  [935.9,75.9],
  [942.3,75.9],
  [948.7,75.9],
  [955.1,75.9],
  [961.5,75.9],
  [967.9,75.9],
  [993.6,75.9],
  [1000,75.9],
  [12.8,82.3],
  [19.2,82.3],
  [25.6,82.3],
  [32.1,82.3],
  [44.9,82.3],
  [76.9,82.3],
  [83.3,82.3],
  [89.7,82.3],
  [96.2,82.3],
  [102.6,82.3],
  [109,82.3],
  [115.4,82.3],
  [121.8,82.3],
  [128.2,82.3],
  [134.6,82.3],
  [141,82.3],
  [147.4,82.3],
  [153.8,82.3],
  [160.3,82.3],
  [166.7,82.3],
  [173.1,82.3],
  [179.5,82.3],
  [185.9,82.3],
  [192.3,82.3],
  [198.7,82.3],
  [205.1,82.3],
  [211.5,82.3],
  [269.2,82.3],
  [275.6,82.3],
  [282.1,82.3],
  [288.5,82.3],
  [519.2,82.3],
  [525.6,82.3],
  [532.1,82.3],
  [538.5,82.3],
  [544.9,82.3],
  [551.3,82.3],
  [589.7,82.3],
  [596.2,82.3],
  [602.6,82.3],
  [609,82.3],
  [615.4,82.3],
  [621.8,82.3],
  [628.2,82.3],
  [634.6,82.3],
  [641,82.3],
  [647.4,82.3],
  [653.8,82.3],
  [660.3,82.3],
  [666.7,82.3],
  [673.1,82.3],
  [679.5,82.3],
  [685.9,82.3],
  [692.3,82.3],
  [698.7,82.3],
  [705.1,82.3],
  [711.5,82.3],
  [717.9,82.3],
  [724.4,82.3],
  [730.8,82.3],
  [737.2,82.3],
  [743.6,82.3],
  [750,82.3],
  [756.4,82.3],
  [762.8,82.3],
  [769.2,82.3],
  [775.6,82.3],
  [782.1,82.3],
  [788.5,82.3],
  [794.9,82.3],
  [801.3,82.3],
  [807.7,82.3],
  [814.1,82.3],
  [820.5,82.3],
  [826.9,82.3],
  [833.3,82.3],
  [839.7,82.3],
  [846.2,82.3],
  [852.6,82.3],
  [859,82.3],
  [865.4,82.3],
  [871.8,82.3],
  [878.2,82.3],
  [884.6,82.3],
  [891,82.3],
  [897.4,82.3],
  [903.8,82.3],
  [910.3,82.3],
  [916.7,82.3],
  [923.1,82.3],
  [929.5,82.3],
  [935.9,82.3],
  [942.3,82.3],
  [948.7,82.3],
  [955.1,82.3],
  [961.5,82.3],
  [987.2,82.3],
  [32.1,88.6],
  [89.7,88.6],
  [96.2,88.6],
  [102.6,88.6],
  [109,88.6],
  [115.4,88.6],
  [121.8,88.6],
  [128.2,88.6],
  [134.6,88.6],
  [141,88.6],
  [147.4,88.6],
  [153.8,88.6],
  [160.3,88.6],
  [166.7,88.6],
  [173.1,88.6],
  [179.5,88.6],
  [185.9,88.6],
  [192.3,88.6],
  [198.7,88.6],
  [205.1,88.6],
  [211.5,88.6],
  [217.9,88.6],
  [269.2,88.6],
  [275.6,88.6],
  [282.1,88.6],
  [288.5,88.6],
  [301.3,88.6],
  [307.7,88.6],
  [519.2,88.6],
  [525.6,88.6],
  [538.5,88.6],
  [544.9,88.6],
  [576.9,88.6],
  [583.3,88.6],
  [589.7,88.6],
  [596.2,88.6],
  [602.6,88.6],
  [609,88.6],
  [615.4,88.6],
  [621.8,88.6],
  [628.2,88.6],
  [634.6,88.6],
  [641,88.6],
  [647.4,88.6],
  [653.8,88.6],
  [660.3,88.6],
  [666.7,88.6],
  [673.1,88.6],
  [679.5,88.6],
  [685.9,88.6],
  [692.3,88.6],
  [698.7,88.6],
  [705.1,88.6],
  [711.5,88.6],
  [717.9,88.6],
  [724.4,88.6],
  [730.8,88.6],
  [737.2,88.6],
  [743.6,88.6],
  [750,88.6],
  [756.4,88.6],
  [762.8,88.6],
  [769.2,88.6],
  [775.6,88.6],
  [782.1,88.6],
  [788.5,88.6],
  [794.9,88.6],
  [801.3,88.6],
  [807.7,88.6],
  [814.1,88.6],
  [820.5,88.6],
  [826.9,88.6],
  [833.3,88.6],
  [839.7,88.6],
  [846.2,88.6],
  [852.6,88.6],
  [859,88.6],
  [865.4,88.6],
  [871.8,88.6],
  [878.2,88.6],
  [884.6,88.6],
  [891,88.6],
  [897.4,88.6],
  [903.8,88.6],
  [910.3,88.6],
  [916.7,88.6],
  [923.1,88.6],
  [980.8,88.6],
  [987.2,88.6],
  [25.6,94.9],
  [38.5,94.9],
  [102.6,94.9],
  [109,94.9],
  [115.4,94.9],
  [121.8,94.9],
  [128.2,94.9],
  [134.6,94.9],
  [141,94.9],
  [147.4,94.9],
  [153.8,94.9],
  [160.3,94.9],
  [166.7,94.9],
  [173.1,94.9],
  [179.5,94.9],
  [185.9,94.9],
  [192.3,94.9],
  [198.7,94.9],
  [205.1,94.9],
  [211.5,94.9],
  [217.9,94.9],
  [269.2,94.9],
  [275.6,94.9],
  [282.1,94.9],
  [288.5,94.9],
  [294.9,94.9],
  [301.3,94.9],
  [307.7,94.9],
  [487.2,94.9],
  [493.6,94.9],
  [538.5,94.9],
  [544.9,94.9],
  [576.9,94.9],
  [583.3,94.9],
  [589.7,94.9],
  [596.2,94.9],
  [602.6,94.9],
  [609,94.9],
  [615.4,94.9],
  [621.8,94.9],
  [628.2,94.9],
  [634.6,94.9],
  [641,94.9],
  [647.4,94.9],
  [653.8,94.9],
  [660.3,94.9],
  [666.7,94.9],
  [673.1,94.9],
  [679.5,94.9],
  [685.9,94.9],
  [692.3,94.9],
  [698.7,94.9],
  [705.1,94.9],
  [711.5,94.9],
  [717.9,94.9],
  [724.4,94.9],
  [730.8,94.9],
  [737.2,94.9],
  [743.6,94.9],
  [750,94.9],
  [756.4,94.9],
  [762.8,94.9],
  [769.2,94.9],
  [775.6,94.9],
  [782.1,94.9],
  [788.5,94.9],
  [794.9,94.9],
  [801.3,94.9],
  [807.7,94.9],
  [814.1,94.9],
  [820.5,94.9],
  [826.9,94.9],
  [833.3,94.9],
  [839.7,94.9],
  [846.2,94.9],
  [852.6,94.9],
  [859,94.9],
  [865.4,94.9],
  [871.8,94.9],
  [878.2,94.9],
  [884.6,94.9],
  [891,94.9],
  [897.4,94.9],
  [903.8,94.9],
  [910.3,94.9],
  [916.7,94.9],
  [974.4,94.9],
  [980.8,94.9],
  [987.2,94.9],
  [19.2,101.3],
  [102.6,101.3],
  [109,101.3],
  [115.4,101.3],
  [121.8,101.3],
  [128.2,101.3],
  [134.6,101.3],
  [141,101.3],
  [147.4,101.3],
  [153.8,101.3],
  [160.3,101.3],
  [166.7,101.3],
  [173.1,101.3],
  [179.5,101.3],
  [185.9,101.3],
  [192.3,101.3],
  [198.7,101.3],
  [205.1,101.3],
  [211.5,101.3],
  [217.9,101.3],
  [224.4,101.3],
  [230.8,101.3],
  [269.2,101.3],
  [275.6,101.3],
  [282.1,101.3],
  [288.5,101.3],
  [294.9,101.3],
  [301.3,101.3],
  [307.7,101.3],
  [487.2,101.3],
  [525.6,101.3],
  [532.1,101.3],
  [538.5,101.3],
  [544.9,101.3],
  [564.1,101.3],
  [570.5,101.3],
  [576.9,101.3],
  [583.3,101.3],
  [589.7,101.3],
  [596.2,101.3],
  [602.6,101.3],
  [609,101.3],
  [615.4,101.3],
  [621.8,101.3],
  [628.2,101.3],
  [634.6,101.3],
  [641,101.3],
  [647.4,101.3],
  [653.8,101.3],
  [660.3,101.3],
  [666.7,101.3],
  [673.1,101.3],
  [679.5,101.3],
  [685.9,101.3],
  [692.3,101.3],
  [698.7,101.3],
  [705.1,101.3],
  [711.5,101.3],
  [717.9,101.3],
  [724.4,101.3],
  [730.8,101.3],
  [737.2,101.3],
  [743.6,101.3],
  [750,101.3],
  [756.4,101.3],
  [762.8,101.3],
  [769.2,101.3],
  [775.6,101.3],
  [782.1,101.3],
  [788.5,101.3],
  [794.9,101.3],
  [801.3,101.3],
  [807.7,101.3],
  [814.1,101.3],
  [820.5,101.3],
  [826.9,101.3],
  [833.3,101.3],
  [839.7,101.3],
  [846.2,101.3],
  [852.6,101.3],
  [859,101.3],
  [865.4,101.3],
  [871.8,101.3],
  [878.2,101.3],
  [884.6,101.3],
  [891,101.3],
  [897.4,101.3],
  [903.8,101.3],
  [910.3,101.3],
  [974.4,101.3],
  [980.8,101.3],
  [987.2,101.3],
  [109,107.6],
  [115.4,107.6],
  [121.8,107.6],
  [128.2,107.6],
  [134.6,107.6],
  [141,107.6],
  [147.4,107.6],
  [153.8,107.6],
  [160.3,107.6],
  [166.7,107.6],
  [173.1,107.6],
  [179.5,107.6],
  [185.9,107.6],
  [192.3,107.6],
  [198.7,107.6],
  [205.1,107.6],
  [211.5,107.6],
  [217.9,107.6],
  [224.4,107.6],
  [230.8,107.6],
  [237.2,107.6],
  [243.6,107.6],
  [250,107.6],
  [269.2,107.6],
  [275.6,107.6],
  [282.1,107.6],
  [288.5,107.6],
  [294.9,107.6],
  [301.3,107.6],
  [307.7,107.6],
  [314.1,107.6],
  [320.5,107.6],
  [487.2,107.6],
  [493.6,107.6],
  [525.6,107.6],
  [564.1,107.6],
  [570.5,107.6],
  [576.9,107.6],
  [583.3,107.6],
  [589.7,107.6],
  [596.2,107.6],
  [602.6,107.6],
  [609,107.6],
  [615.4,107.6],
  [621.8,107.6],
  [628.2,107.6],
  [634.6,107.6],
  [641,107.6],
  [647.4,107.6],
  [653.8,107.6],
  [660.3,107.6],
  [666.7,107.6],
  [673.1,107.6],
  [679.5,107.6],
  [685.9,107.6],
  [692.3,107.6],
  [698.7,107.6],
  [705.1,107.6],
  [711.5,107.6],
  [717.9,107.6],
  [724.4,107.6],
  [730.8,107.6],
  [737.2,107.6],
  [743.6,107.6],
  [750,107.6],
  [756.4,107.6],
  [762.8,107.6],
  [769.2,107.6],
  [775.6,107.6],
  [782.1,107.6],
  [788.5,107.6],
  [794.9,107.6],
  [801.3,107.6],
  [807.7,107.6],
  [814.1,107.6],
  [820.5,107.6],
  [826.9,107.6],
  [833.3,107.6],
  [839.7,107.6],
  [846.2,107.6],
  [852.6,107.6],
  [859,107.6],
  [865.4,107.6],
  [871.8,107.6],
  [878.2,107.6],
  [884.6,107.6],
  [891,107.6],
  [897.4,107.6],
  [903.8,107.6],
  [974.4,107.6],
  [980.8,107.6],
  [987.2,107.6],
  [102.6,113.9],
  [109,113.9],
  [115.4,113.9],
  [121.8,113.9],
  [128.2,113.9],
  [134.6,113.9],
  [141,113.9],
  [147.4,113.9],
  [153.8,113.9],
  [160.3,113.9],
  [166.7,113.9],
  [173.1,113.9],
  [179.5,113.9],
  [185.9,113.9],
  [192.3,113.9],
  [198.7,113.9],
  [205.1,113.9],
  [211.5,113.9],
  [217.9,113.9],
  [224.4,113.9],
  [230.8,113.9],
  [237.2,113.9],
  [243.6,113.9],
  [250,113.9],
  [262.8,113.9],
  [269.2,113.9],
  [275.6,113.9],
  [282.1,113.9],
  [288.5,113.9],
  [294.9,113.9],
  [301.3,113.9],
  [307.7,113.9],
  [314.1,113.9],
  [320.5,113.9],
  [326.9,113.9],
  [474.4,113.9],
  [480.8,113.9],
  [493.6,113.9],
  [532.1,113.9],
  [538.5,113.9],
  [544.9,113.9],
  [551.3,113.9],
  [557.7,113.9],
  [564.1,113.9],
  [570.5,113.9],
  [576.9,113.9],
  [583.3,113.9],
  [589.7,113.9],
  [596.2,113.9],
  [602.6,113.9],
  [609,113.9],
  [615.4,113.9],
  [621.8,113.9],
  [628.2,113.9],
  [634.6,113.9],
  [641,113.9],
  [647.4,113.9],
  [653.8,113.9],
  [660.3,113.9],
  [666.7,113.9],
  [673.1,113.9],
  [679.5,113.9],
  [685.9,113.9],
  [692.3,113.9],
  [698.7,113.9],
  [705.1,113.9],
  [711.5,113.9],
  [717.9,113.9],
  [724.4,113.9],
  [730.8,113.9],
  [737.2,113.9],
  [743.6,113.9],
  [750,113.9],
  [756.4,113.9],
  [762.8,113.9],
  [769.2,113.9],
  [775.6,113.9],
  [782.1,113.9],
  [788.5,113.9],
  [794.9,113.9],
  [801.3,113.9],
  [807.7,113.9],
  [814.1,113.9],
  [820.5,113.9],
  [826.9,113.9],
  [833.3,113.9],
  [839.7,113.9],
  [846.2,113.9],
  [852.6,113.9],
  [859,113.9],
  [865.4,113.9],
  [871.8,113.9],
  [878.2,113.9],
  [884.6,113.9],
  [891,113.9],
  [897.4,113.9],
  [903.8,113.9],
  [910.3,113.9],
  [974.4,113.9],
  [980.8,113.9],
  [102.6,120.3],
  [115.4,120.3],
  [121.8,120.3],
  [128.2,120.3],
  [134.6,120.3],
  [141,120.3],
  [147.4,120.3],
  [153.8,120.3],
  [160.3,120.3],
  [166.7,120.3],
  [173.1,120.3],
  [179.5,120.3],
  [185.9,120.3],
  [192.3,120.3],
  [198.7,120.3],
  [205.1,120.3],
  [211.5,120.3],
  [217.9,120.3],
  [224.4,120.3],
  [230.8,120.3],
  [237.2,120.3],
  [243.6,120.3],
  [250,120.3],
  [269.2,120.3],
  [275.6,120.3],
  [282.1,120.3],
  [288.5,120.3],
  [294.9,120.3],
  [301.3,120.3],
  [307.7,120.3],
  [314.1,120.3],
  [320.5,120.3],
  [326.9,120.3],
  [474.4,120.3],
  [487.2,120.3],
  [493.6,120.3],
  [500,120.3],
  [519.2,120.3],
  [525.6,120.3],
  [532.1,120.3],
  [538.5,120.3],
  [544.9,120.3],
  [551.3,120.3],
  [557.7,120.3],
  [564.1,120.3],
  [570.5,120.3],
  [576.9,120.3],
  [583.3,120.3],
  [589.7,120.3],
  [596.2,120.3],
  [602.6,120.3],
  [609,120.3],
  [615.4,120.3],
  [621.8,120.3],
  [628.2,120.3],
  [634.6,120.3],
  [641,120.3],
  [647.4,120.3],
  [653.8,120.3],
  [660.3,120.3],
  [666.7,120.3],
  [673.1,120.3],
  [679.5,120.3],
  [685.9,120.3],
  [692.3,120.3],
  [698.7,120.3],
  [705.1,120.3],
  [711.5,120.3],
  [717.9,120.3],
  [724.4,120.3],
  [730.8,120.3],
  [737.2,120.3],
  [743.6,120.3],
  [750,120.3],
  [756.4,120.3],
  [762.8,120.3],
  [769.2,120.3],
  [775.6,120.3],
  [782.1,120.3],
  [788.5,120.3],
  [794.9,120.3],
  [801.3,120.3],
  [807.7,120.3],
  [814.1,120.3],
  [820.5,120.3],
  [826.9,120.3],
  [833.3,120.3],
  [839.7,120.3],
  [846.2,120.3],
  [852.6,120.3],
  [859,120.3],
  [865.4,120.3],
  [871.8,120.3],
  [878.2,120.3],
  [884.6,120.3],
  [891,120.3],
  [897.4,120.3],
  [903.8,120.3],
  [910.3,120.3],
  [916.7,120.3],
  [923.1,120.3],
  [929.5,120.3],
  [974.4,120.3],
  [115.4,126.6],
  [121.8,126.6],
  [128.2,126.6],
  [134.6,126.6],
  [141,126.6],
  [147.4,126.6],
  [153.8,126.6],
  [160.3,126.6],
  [166.7,126.6],
  [173.1,126.6],
  [179.5,126.6],
  [185.9,126.6],
  [192.3,126.6],
  [198.7,126.6],
  [205.1,126.6],
  [211.5,126.6],
  [217.9,126.6],
  [224.4,126.6],
  [230.8,126.6],
  [237.2,126.6],
  [243.6,126.6],
  [250,126.6],
  [256.4,126.6],
  [262.8,126.6],
  [269.2,126.6],
  [275.6,126.6],
  [282.1,126.6],
  [288.5,126.6],
  [294.9,126.6],
  [301.3,126.6],
  [307.7,126.6],
  [314.1,126.6],
  [320.5,126.6],
  [493.6,126.6],
  [500,126.6],
  [512.8,126.6],
  [519.2,126.6],
  [525.6,126.6],
  [532.1,126.6],
  [538.5,126.6],
  [544.9,126.6],
  [551.3,126.6],
  [557.7,126.6],
  [564.1,126.6],
  [570.5,126.6],
  [576.9,126.6],
  [583.3,126.6],
  [589.7,126.6],
  [596.2,126.6],
  [602.6,126.6],
  [609,126.6],
  [615.4,126.6],
  [621.8,126.6],
  [628.2,126.6],
  [634.6,126.6],
  [641,126.6],
  [647.4,126.6],
  [653.8,126.6],
  [660.3,126.6],
  [666.7,126.6],
  [673.1,126.6],
  [679.5,126.6],
  [685.9,126.6],
  [692.3,126.6],
  [698.7,126.6],
  [705.1,126.6],
  [711.5,126.6],
  [717.9,126.6],
  [724.4,126.6],
  [730.8,126.6],
  [737.2,126.6],
  [743.6,126.6],
  [750,126.6],
  [756.4,126.6],
  [762.8,126.6],
  [769.2,126.6],
  [775.6,126.6],
  [782.1,126.6],
  [788.5,126.6],
  [794.9,126.6],
  [801.3,126.6],
  [807.7,126.6],
  [814.1,126.6],
  [820.5,126.6],
  [826.9,126.6],
  [833.3,126.6],
  [839.7,126.6],
  [846.2,126.6],
  [852.6,126.6],
  [859,126.6],
  [865.4,126.6],
  [871.8,126.6],
  [878.2,126.6],
  [884.6,126.6],
  [891,126.6],
  [897.4,126.6],
  [903.8,126.6],
  [910.3,126.6],
  [916.7,126.6],
  [923.1,126.6],
  [929.5,126.6],
  [115.4,132.9],
  [121.8,132.9],
  [128.2,132.9],
  [134.6,132.9],
  [141,132.9],
  [147.4,132.9],
  [153.8,132.9],
  [160.3,132.9],
  [166.7,132.9],
  [173.1,132.9],
  [179.5,132.9],
  [185.9,132.9],
  [192.3,132.9],
  [198.7,132.9],
  [205.1,132.9],
  [211.5,132.9],
  [217.9,132.9],
  [224.4,132.9],
  [230.8,132.9],
  [237.2,132.9],
  [243.6,132.9],
  [250,132.9],
  [256.4,132.9],
  [262.8,132.9],
  [269.2,132.9],
  [275.6,132.9],
  [282.1,132.9],
  [288.5,132.9],
  [294.9,132.9],
  [326.9,132.9],
  [506.4,132.9],
  [512.8,132.9],
  [519.2,132.9],
  [525.6,132.9],
  [532.1,132.9],
  [538.5,132.9],
  [544.9,132.9],
  [551.3,132.9],
  [557.7,132.9],
  [564.1,132.9],
  [570.5,132.9],
  [576.9,132.9],
  [583.3,132.9],
  [589.7,132.9],
  [596.2,132.9],
  [602.6,132.9],
  [609,132.9],
  [615.4,132.9],
  [621.8,132.9],
  [628.2,132.9],
  [634.6,132.9],
  [641,132.9],
  [647.4,132.9],
  [653.8,132.9],
  [660.3,132.9],
  [666.7,132.9],
  [673.1,132.9],
  [679.5,132.9],
  [685.9,132.9],
  [692.3,132.9],
  [698.7,132.9],
  [705.1,132.9],
  [711.5,132.9],
  [717.9,132.9],
  [724.4,132.9],
  [730.8,132.9],
  [737.2,132.9],
  [743.6,132.9],
  [750,132.9],
  [756.4,132.9],
  [762.8,132.9],
  [769.2,132.9],
  [775.6,132.9],
  [782.1,132.9],
  [788.5,132.9],
  [794.9,132.9],
  [801.3,132.9],
  [807.7,132.9],
  [814.1,132.9],
  [820.5,132.9],
  [826.9,132.9],
  [833.3,132.9],
  [839.7,132.9],
  [846.2,132.9],
  [852.6,132.9],
  [859,132.9],
  [865.4,132.9],
  [871.8,132.9],
  [878.2,132.9],
  [884.6,132.9],
  [891,132.9],
  [897.4,132.9],
  [903.8,132.9],
  [910.3,132.9],
  [916.7,132.9],
  [923.1,132.9],
  [929.5,132.9],
  [134.6,139.2],
  [141,139.2],
  [147.4,139.2],
  [153.8,139.2],
  [160.3,139.2],
  [166.7,139.2],
  [173.1,139.2],
  [179.5,139.2],
  [185.9,139.2],
  [192.3,139.2],
  [198.7,139.2],
  [205.1,139.2],
  [211.5,139.2],
  [217.9,139.2],
  [224.4,139.2],
  [230.8,139.2],
  [237.2,139.2],
  [243.6,139.2],
  [250,139.2],
  [256.4,139.2],
  [262.8,139.2],
  [269.2,139.2],
  [275.6,139.2],
  [282.1,139.2],
  [288.5,139.2],
  [301.3,139.2],
  [326.9,139.2],
  [333.3,139.2],
  [339.7,139.2],
  [487.2,139.2],
  [493.6,139.2],
  [500,139.2],
  [506.4,139.2],
  [512.8,139.2],
  [519.2,139.2],
  [525.6,139.2],
  [532.1,139.2],
  [538.5,139.2],
  [544.9,139.2],
  [551.3,139.2],
  [557.7,139.2],
  [564.1,139.2],
  [570.5,139.2],
  [576.9,139.2],
  [583.3,139.2],
  [589.7,139.2],
  [596.2,139.2],
  [602.6,139.2],
  [609,139.2],
  [615.4,139.2],
  [621.8,139.2],
  [628.2,139.2],
  [634.6,139.2],
  [641,139.2],
  [647.4,139.2],
  [653.8,139.2],
  [660.3,139.2],
  [666.7,139.2],
  [673.1,139.2],
  [679.5,139.2],
  [685.9,139.2],
  [692.3,139.2],
  [698.7,139.2],
  [705.1,139.2],
  [711.5,139.2],
  [717.9,139.2],
  [724.4,139.2],
  [730.8,139.2],
  [737.2,139.2],
  [743.6,139.2],
  [750,139.2],
  [756.4,139.2],
  [762.8,139.2],
  [769.2,139.2],
  [775.6,139.2],
  [782.1,139.2],
  [788.5,139.2],
  [794.9,139.2],
  [801.3,139.2],
  [807.7,139.2],
  [814.1,139.2],
  [820.5,139.2],
  [826.9,139.2],
  [833.3,139.2],
  [839.7,139.2],
  [846.2,139.2],
  [852.6,139.2],
  [859,139.2],
  [865.4,139.2],
  [871.8,139.2],
  [878.2,139.2],
  [884.6,139.2],
  [891,139.2],
  [897.4,139.2],
  [903.8,139.2],
  [910.3,139.2],
  [916.7,139.2],
  [929.5,139.2],
  [128.2,145.6],
  [134.6,145.6],
  [141,145.6],
  [147.4,145.6],
  [153.8,145.6],
  [160.3,145.6],
  [166.7,145.6],
  [173.1,145.6],
  [179.5,145.6],
  [185.9,145.6],
  [192.3,145.6],
  [198.7,145.6],
  [205.1,145.6],
  [211.5,145.6],
  [217.9,145.6],
  [224.4,145.6],
  [230.8,145.6],
  [237.2,145.6],
  [243.6,145.6],
  [250,145.6],
  [256.4,145.6],
  [262.8,145.6],
  [269.2,145.6],
  [275.6,145.6],
  [282.1,145.6],
  [294.9,145.6],
  [301.3,145.6],
  [333.3,145.6],
  [339.7,145.6],
  [493.6,145.6],
  [500,145.6],
  [506.4,145.6],
  [512.8,145.6],
  [519.2,145.6],
  [525.6,145.6],
  [532.1,145.6],
  [538.5,145.6],
  [544.9,145.6],
  [551.3,145.6],
  [557.7,145.6],
  [564.1,145.6],
  [570.5,145.6],
  [576.9,145.6],
  [583.3,145.6],
  [589.7,145.6],
  [596.2,145.6],
  [602.6,145.6],
  [609,145.6],
  [615.4,145.6],
  [621.8,145.6],
  [628.2,145.6],
  [634.6,145.6],
  [641,145.6],
  [647.4,145.6],
  [653.8,145.6],
  [660.3,145.6],
  [666.7,145.6],
  [673.1,145.6],
  [679.5,145.6],
  [685.9,145.6],
  [692.3,145.6],
  [698.7,145.6],
  [705.1,145.6],
  [711.5,145.6],
  [717.9,145.6],
  [724.4,145.6],
  [730.8,145.6],
  [737.2,145.6],
  [743.6,145.6],
  [750,145.6],
  [756.4,145.6],
  [762.8,145.6],
  [769.2,145.6],
  [775.6,145.6],
  [782.1,145.6],
  [788.5,145.6],
  [794.9,145.6],
  [801.3,145.6],
  [807.7,145.6],
  [814.1,145.6],
  [820.5,145.6],
  [826.9,145.6],
  [833.3,145.6],
  [839.7,145.6],
  [846.2,145.6],
  [852.6,145.6],
  [859,145.6],
  [865.4,145.6],
  [871.8,145.6],
  [878.2,145.6],
  [884.6,145.6],
  [891,145.6],
  [897.4,145.6],
  [903.8,145.6],
  [910.3,145.6],
  [916.7,145.6],
  [929.5,145.6],
  [128.2,151.9],
  [134.6,151.9],
  [141,151.9],
  [147.4,151.9],
  [153.8,151.9],
  [160.3,151.9],
  [166.7,151.9],
  [173.1,151.9],
  [179.5,151.9],
  [185.9,151.9],
  [192.3,151.9],
  [198.7,151.9],
  [205.1,151.9],
  [211.5,151.9],
  [217.9,151.9],
  [224.4,151.9],
  [230.8,151.9],
  [237.2,151.9],
  [243.6,151.9],
  [250,151.9],
  [256.4,151.9],
  [262.8,151.9],
  [269.2,151.9],
  [275.6,151.9],
  [282.1,151.9],
  [288.5,151.9],
  [294.9,151.9],
  [301.3,151.9],
  [307.7,151.9],
  [314.1,151.9],
  [500,151.9],
  [506.4,151.9],
  [512.8,151.9],
  [519.2,151.9],
  [525.6,151.9],
  [532.1,151.9],
  [538.5,151.9],
  [544.9,151.9],
  [551.3,151.9],
  [557.7,151.9],
  [564.1,151.9],
  [570.5,151.9],
  [576.9,151.9],
  [583.3,151.9],
  [589.7,151.9],
  [602.6,151.9],
  [615.4,151.9],
  [621.8,151.9],
  [628.2,151.9],
  [634.6,151.9],
  [641,151.9],
  [660.3,151.9],
  [666.7,151.9],
  [673.1,151.9],
  [679.5,151.9],
  [685.9,151.9],
  [692.3,151.9],
  [698.7,151.9],
  [705.1,151.9],
  [711.5,151.9],
  [717.9,151.9],
  [724.4,151.9],
  [730.8,151.9],
  [737.2,151.9],
  [743.6,151.9],
  [750,151.9],
  [756.4,151.9],
  [762.8,151.9],
  [769.2,151.9],
  [775.6,151.9],
  [782.1,151.9],
  [788.5,151.9],
  [794.9,151.9],
  [801.3,151.9],
  [807.7,151.9],
  [814.1,151.9],
  [820.5,151.9],
  [826.9,151.9],
  [833.3,151.9],
  [839.7,151.9],
  [846.2,151.9],
  [852.6,151.9],
  [859,151.9],
  [865.4,151.9],
  [871.8,151.9],
  [878.2,151.9],
  [884.6,151.9],
  [891,151.9],
  [897.4,151.9],
  [903.8,151.9],
  [910.3,151.9],
  [128.2,158.2],
  [134.6,158.2],
  [141,158.2],
  [147.4,158.2],
  [153.8,158.2],
  [160.3,158.2],
  [166.7,158.2],
  [173.1,158.2],
  [179.5,158.2],
  [185.9,158.2],
  [192.3,158.2],
  [198.7,158.2],
  [205.1,158.2],
  [211.5,158.2],
  [217.9,158.2],
  [224.4,158.2],
  [230.8,158.2],
  [237.2,158.2],
  [243.6,158.2],
  [250,158.2],
  [256.4,158.2],
  [262.8,158.2],
  [269.2,158.2],
  [275.6,158.2],
  [282.1,158.2],
  [288.5,158.2],
  [301.3,158.2],
  [500,158.2],
  [506.4,158.2],
  [512.8,158.2],
  [519.2,158.2],
  [532.1,158.2],
  [551.3,158.2],
  [557.7,158.2],
  [564.1,158.2],
  [570.5,158.2],
  [576.9,158.2],
  [583.3,158.2],
  [621.8,158.2],
  [628.2,158.2],
  [634.6,158.2],
  [641,158.2],
  [653.8,158.2],
  [660.3,158.2],
  [666.7,158.2],
  [673.1,158.2],
  [679.5,158.2],
  [685.9,158.2],
  [692.3,158.2],
  [698.7,158.2],
  [705.1,158.2],
  [711.5,158.2],
  [717.9,158.2],
  [724.4,158.2],
  [730.8,158.2],
  [737.2,158.2],
  [743.6,158.2],
  [750,158.2],
  [756.4,158.2],
  [762.8,158.2],
  [769.2,158.2],
  [775.6,158.2],
  [782.1,158.2],
  [788.5,158.2],
  [794.9,158.2],
  [801.3,158.2],
  [807.7,158.2],
  [814.1,158.2],
  [820.5,158.2],
  [826.9,158.2],
  [833.3,158.2],
  [839.7,158.2],
  [846.2,158.2],
  [852.6,158.2],
  [859,158.2],
  [865.4,158.2],
  [871.8,158.2],
  [878.2,158.2],
  [884.6,158.2],
  [891,158.2],
  [897.4,158.2],
  [903.8,158.2],
  [929.5,158.2],
  [128.2,164.6],
  [134.6,164.6],
  [141,164.6],
  [147.4,164.6],
  [153.8,164.6],
  [160.3,164.6],
  [166.7,164.6],
  [173.1,164.6],
  [179.5,164.6],
  [185.9,164.6],
  [192.3,164.6],
  [198.7,164.6],
  [205.1,164.6],
  [211.5,164.6],
  [217.9,164.6],
  [224.4,164.6],
  [230.8,164.6],
  [237.2,164.6],
  [243.6,164.6],
  [250,164.6],
  [256.4,164.6],
  [262.8,164.6],
  [269.2,164.6],
  [275.6,164.6],
  [282.1,164.6],
  [474.4,164.6],
  [480.8,164.6],
  [487.2,164.6],
  [493.6,164.6],
  [500,164.6],
  [506.4,164.6],
  [538.5,164.6],
  [557.7,164.6],
  [564.1,164.6],
  [570.5,164.6],
  [576.9,164.6],
  [583.3,164.6],
  [628.2,164.6],
  [634.6,164.6],
  [641,164.6],
  [660.3,164.6],
  [666.7,164.6],
  [673.1,164.6],
  [679.5,164.6],
  [685.9,164.6],
  [692.3,164.6],
  [698.7,164.6],
  [705.1,164.6],
  [711.5,164.6],
  [717.9,164.6],
  [724.4,164.6],
  [730.8,164.6],
  [737.2,164.6],
  [743.6,164.6],
  [750,164.6],
  [756.4,164.6],
  [762.8,164.6],
  [769.2,164.6],
  [775.6,164.6],
  [782.1,164.6],
  [788.5,164.6],
  [794.9,164.6],
  [801.3,164.6],
  [807.7,164.6],
  [814.1,164.6],
  [820.5,164.6],
  [826.9,164.6],
  [833.3,164.6],
  [839.7,164.6],
  [846.2,164.6],
  [852.6,164.6],
  [859,164.6],
  [865.4,164.6],
  [871.8,164.6],
  [878.2,164.6],
  [884.6,164.6],
  [891,164.6],
  [923.1,164.6],
  [929.5,164.6],
  [128.2,170.9],
  [134.6,170.9],
  [141,170.9],
  [147.4,170.9],
  [153.8,170.9],
  [160.3,170.9],
  [166.7,170.9],
  [173.1,170.9],
  [179.5,170.9],
  [185.9,170.9],
  [192.3,170.9],
  [198.7,170.9],
  [205.1,170.9],
  [211.5,170.9],
  [217.9,170.9],
  [224.4,170.9],
  [230.8,170.9],
  [237.2,170.9],
  [243.6,170.9],
  [250,170.9],
  [256.4,170.9],
  [262.8,170.9],
  [269.2,170.9],
  [275.6,170.9],
  [282.1,170.9],
  [474.4,170.9],
  [480.8,170.9],
  [487.2,170.9],
  [493.6,170.9],
  [500,170.9],
  [544.9,170.9],
  [551.3,170.9],
  [564.1,170.9],
  [570.5,170.9],
  [576.9,170.9],
  [583.3,170.9],
  [589.7,170.9],
  [596.2,170.9],
  [602.6,170.9],
  [609,170.9],
  [621.8,170.9],
  [628.2,170.9],
  [634.6,170.9],
  [641,170.9],
  [647.4,170.9],
  [666.7,170.9],
  [673.1,170.9],
  [679.5,170.9],
  [685.9,170.9],
  [692.3,170.9],
  [698.7,170.9],
  [705.1,170.9],
  [711.5,170.9],
  [717.9,170.9],
  [724.4,170.9],
  [730.8,170.9],
  [737.2,170.9],
  [743.6,170.9],
  [750,170.9],
  [756.4,170.9],
  [762.8,170.9],
  [769.2,170.9],
  [775.6,170.9],
  [782.1,170.9],
  [788.5,170.9],
  [794.9,170.9],
  [801.3,170.9],
  [807.7,170.9],
  [814.1,170.9],
  [820.5,170.9],
  [826.9,170.9],
  [833.3,170.9],
  [839.7,170.9],
  [846.2,170.9],
  [852.6,170.9],
  [859,170.9],
  [865.4,170.9],
  [871.8,170.9],
  [878.2,170.9],
  [884.6,170.9],
  [923.1,170.9],
  [128.2,177.2],
  [134.6,177.2],
  [141,177.2],
  [147.4,177.2],
  [153.8,177.2],
  [160.3,177.2],
  [166.7,177.2],
  [173.1,177.2],
  [179.5,177.2],
  [185.9,177.2],
  [192.3,177.2],
  [198.7,177.2],
  [205.1,177.2],
  [211.5,177.2],
  [217.9,177.2],
  [224.4,177.2],
  [230.8,177.2],
  [237.2,177.2],
  [243.6,177.2],
  [250,177.2],
  [256.4,177.2],
  [262.8,177.2],
  [269.2,177.2],
  [474.4,177.2],
  [480.8,177.2],
  [487.2,177.2],
  [493.6,177.2],
  [525.6,177.2],
  [551.3,177.2],
  [564.1,177.2],
  [583.3,177.2],
  [589.7,177.2],
  [596.2,177.2],
  [602.6,177.2],
  [609,177.2],
  [615.4,177.2],
  [621.8,177.2],
  [628.2,177.2],
  [634.6,177.2],
  [641,177.2],
  [647.4,177.2],
  [660.3,177.2],
  [666.7,177.2],
  [673.1,177.2],
  [679.5,177.2],
  [685.9,177.2],
  [692.3,177.2],
  [698.7,177.2],
  [705.1,177.2],
  [711.5,177.2],
  [717.9,177.2],
  [724.4,177.2],
  [730.8,177.2],
  [737.2,177.2],
  [743.6,177.2],
  [750,177.2],
  [756.4,177.2],
  [762.8,177.2],
  [769.2,177.2],
  [775.6,177.2],
  [782.1,177.2],
  [788.5,177.2],
  [794.9,177.2],
  [801.3,177.2],
  [807.7,177.2],
  [814.1,177.2],
  [820.5,177.2],
  [826.9,177.2],
  [833.3,177.2],
  [839.7,177.2],
  [846.2,177.2],
  [852.6,177.2],
  [859,177.2],
  [878.2,177.2],
  [923.1,177.2],
  [134.6,183.5],
  [141,183.5],
  [147.4,183.5],
  [153.8,183.5],
  [160.3,183.5],
  [166.7,183.5],
  [173.1,183.5],
  [179.5,183.5],
  [185.9,183.5],
  [192.3,183.5],
  [198.7,183.5],
  [205.1,183.5],
  [211.5,183.5],
  [217.9,183.5],
  [224.4,183.5],
  [230.8,183.5],
  [237.2,183.5],
  [243.6,183.5],
  [250,183.5],
  [256.4,183.5],
  [262.8,183.5],
  [269.2,183.5],
  [474.4,183.5],
  [480.8,183.5],
  [487.2,183.5],
  [493.6,183.5],
  [538.5,183.5],
  [544.9,183.5],
  [583.3,183.5],
  [589.7,183.5],
  [596.2,183.5],
  [602.6,183.5],
  [609,183.5],
  [615.4,183.5],
  [621.8,183.5],
  [628.2,183.5],
  [634.6,183.5],
  [641,183.5],
  [647.4,183.5],
  [666.7,183.5],
  [673.1,183.5],
  [679.5,183.5],
  [685.9,183.5],
  [692.3,183.5],
  [698.7,183.5],
  [705.1,183.5],
  [711.5,183.5],
  [717.9,183.5],
  [724.4,183.5],
  [730.8,183.5],
  [737.2,183.5],
  [743.6,183.5],
  [750,183.5],
  [756.4,183.5],
  [762.8,183.5],
  [769.2,183.5],
  [775.6,183.5],
  [782.1,183.5],
  [788.5,183.5],
  [794.9,183.5],
  [801.3,183.5],
  [807.7,183.5],
  [814.1,183.5],
  [820.5,183.5],
  [826.9,183.5],
  [833.3,183.5],
  [839.7,183.5],
  [846.2,183.5],
  [852.6,183.5],
  [878.2,183.5],
  [884.6,183.5],
  [923.1,183.5],
  [134.6,189.9],
  [141,189.9],
  [147.4,189.9],
  [153.8,189.9],
  [160.3,189.9],
  [166.7,189.9],
  [173.1,189.9],
  [179.5,189.9],
  [185.9,189.9],
  [192.3,189.9],
  [198.7,189.9],
  [205.1,189.9],
  [211.5,189.9],
  [217.9,189.9],
  [224.4,189.9],
  [230.8,189.9],
  [237.2,189.9],
  [243.6,189.9],
  [250,189.9],
  [256.4,189.9],
  [262.8,189.9],
  [269.2,189.9],
  [506.4,189.9],
  [512.8,189.9],
  [519.2,189.9],
  [525.6,189.9],
  [609,189.9],
  [615.4,189.9],
  [621.8,189.9],
  [628.2,189.9],
  [634.6,189.9],
  [641,189.9],
  [647.4,189.9],
  [653.8,189.9],
  [660.3,189.9],
  [666.7,189.9],
  [673.1,189.9],
  [679.5,189.9],
  [685.9,189.9],
  [692.3,189.9],
  [698.7,189.9],
  [705.1,189.9],
  [711.5,189.9],
  [717.9,189.9],
  [724.4,189.9],
  [730.8,189.9],
  [737.2,189.9],
  [743.6,189.9],
  [750,189.9],
  [756.4,189.9],
  [762.8,189.9],
  [769.2,189.9],
  [775.6,189.9],
  [782.1,189.9],
  [788.5,189.9],
  [794.9,189.9],
  [801.3,189.9],
  [807.7,189.9],
  [814.1,189.9],
  [820.5,189.9],
  [826.9,189.9],
  [833.3,189.9],
  [839.7,189.9],
  [846.2,189.9],
  [852.6,189.9],
  [859,189.9],
  [884.6,189.9],
  [910.3,189.9],
  [916.7,189.9],
  [923.1,189.9],
  [141,196.2],
  [147.4,196.2],
  [153.8,196.2],
  [160.3,196.2],
  [166.7,196.2],
  [173.1,196.2],
  [179.5,196.2],
  [185.9,196.2],
  [192.3,196.2],
  [198.7,196.2],
  [205.1,196.2],
  [211.5,196.2],
  [217.9,196.2],
  [224.4,196.2],
  [230.8,196.2],
  [237.2,196.2],
  [243.6,196.2],
  [250,196.2],
  [256.4,196.2],
  [262.8,196.2],
  [480.8,196.2],
  [487.2,196.2],
  [493.6,196.2],
  [500,196.2],
  [506.4,196.2],
  [512.8,196.2],
  [519.2,196.2],
  [525.6,196.2],
  [609,196.2],
  [615.4,196.2],
  [621.8,196.2],
  [628.2,196.2],
  [634.6,196.2],
  [641,196.2],
  [647.4,196.2],
  [653.8,196.2],
  [660.3,196.2],
  [666.7,196.2],
  [673.1,196.2],
  [679.5,196.2],
  [685.9,196.2],
  [692.3,196.2],
  [698.7,196.2],
  [705.1,196.2],
  [711.5,196.2],
  [717.9,196.2],
  [724.4,196.2],
  [730.8,196.2],
  [737.2,196.2],
  [743.6,196.2],
  [750,196.2],
  [756.4,196.2],
  [762.8,196.2],
  [769.2,196.2],
  [775.6,196.2],
  [782.1,196.2],
  [788.5,196.2],
  [794.9,196.2],
  [801.3,196.2],
  [807.7,196.2],
  [814.1,196.2],
  [820.5,196.2],
  [826.9,196.2],
  [833.3,196.2],
  [839.7,196.2],
  [846.2,196.2],
  [852.6,196.2],
  [859,196.2],
  [897.4,196.2],
  [903.8,196.2],
  [910.3,196.2],
  [147.4,202.5],
  [153.8,202.5],
  [160.3,202.5],
  [166.7,202.5],
  [173.1,202.5],
  [179.5,202.5],
  [185.9,202.5],
  [192.3,202.5],
  [198.7,202.5],
  [205.1,202.5],
  [211.5,202.5],
  [217.9,202.5],
  [224.4,202.5],
  [230.8,202.5],
  [237.2,202.5],
  [243.6,202.5],
  [250,202.5],
  [256.4,202.5],
  [474.4,202.5],
  [480.8,202.5],
  [487.2,202.5],
  [493.6,202.5],
  [500,202.5],
  [506.4,202.5],
  [512.8,202.5],
  [519.2,202.5],
  [525.6,202.5],
  [532.1,202.5],
  [538.5,202.5],
  [564.1,202.5],
  [609,202.5],
  [615.4,202.5],
  [621.8,202.5],
  [628.2,202.5],
  [634.6,202.5],
  [641,202.5],
  [647.4,202.5],
  [653.8,202.5],
  [660.3,202.5],
  [666.7,202.5],
  [673.1,202.5],
  [679.5,202.5],
  [685.9,202.5],
  [692.3,202.5],
  [698.7,202.5],
  [705.1,202.5],
  [711.5,202.5],
  [717.9,202.5],
  [724.4,202.5],
  [730.8,202.5],
  [737.2,202.5],
  [743.6,202.5],
  [750,202.5],
  [756.4,202.5],
  [762.8,202.5],
  [769.2,202.5],
  [775.6,202.5],
  [782.1,202.5],
  [788.5,202.5],
  [794.9,202.5],
  [801.3,202.5],
  [807.7,202.5],
  [814.1,202.5],
  [820.5,202.5],
  [826.9,202.5],
  [833.3,202.5],
  [839.7,202.5],
  [846.2,202.5],
  [852.6,202.5],
  [859,202.5],
  [153.8,208.9],
  [160.3,208.9],
  [166.7,208.9],
  [173.1,208.9],
  [179.5,208.9],
  [185.9,208.9],
  [192.3,208.9],
  [198.7,208.9],
  [205.1,208.9],
  [211.5,208.9],
  [217.9,208.9],
  [224.4,208.9],
  [230.8,208.9],
  [237.2,208.9],
  [243.6,208.9],
  [250,208.9],
  [474.4,208.9],
  [480.8,208.9],
  [487.2,208.9],
  [493.6,208.9],
  [500,208.9],
  [506.4,208.9],
  [512.8,208.9],
  [519.2,208.9],
  [525.6,208.9],
  [532.1,208.9],
  [538.5,208.9],
  [544.9,208.9],
  [551.3,208.9],
  [564.1,208.9],
  [570.5,208.9],
  [576.9,208.9],
  [583.3,208.9],
  [589.7,208.9],
  [596.2,208.9],
  [602.6,208.9],
  [609,208.9],
  [615.4,208.9],
  [621.8,208.9],
  [628.2,208.9],
  [634.6,208.9],
  [641,208.9],
  [647.4,208.9],
  [653.8,208.9],
  [660.3,208.9],
  [666.7,208.9],
  [673.1,208.9],
  [679.5,208.9],
  [685.9,208.9],
  [692.3,208.9],
  [698.7,208.9],
  [705.1,208.9],
  [711.5,208.9],
  [717.9,208.9],
  [724.4,208.9],
  [730.8,208.9],
  [737.2,208.9],
  [743.6,208.9],
  [750,208.9],
  [756.4,208.9],
  [762.8,208.9],
  [769.2,208.9],
  [775.6,208.9],
  [782.1,208.9],
  [788.5,208.9],
  [794.9,208.9],
  [801.3,208.9],
  [807.7,208.9],
  [814.1,208.9],
  [820.5,208.9],
  [826.9,208.9],
  [833.3,208.9],
  [839.7,208.9],
  [846.2,208.9],
  [852.6,208.9],
  [859,208.9],
  [865.4,208.9],
  [166.7,215.2],
  [173.1,215.2],
  [179.5,215.2],
  [185.9,215.2],
  [192.3,215.2],
  [198.7,215.2],
  [205.1,215.2],
  [211.5,215.2],
  [256.4,215.2],
  [467.9,215.2],
  [474.4,215.2],
  [480.8,215.2],
  [487.2,215.2],
  [493.6,215.2],
  [500,215.2],
  [506.4,215.2],
  [512.8,215.2],
  [519.2,215.2],
  [525.6,215.2],
  [532.1,215.2],
  [538.5,215.2],
  [544.9,215.2],
  [551.3,215.2],
  [557.7,215.2],
  [564.1,215.2],
  [570.5,215.2],
  [576.9,215.2],
  [583.3,215.2],
  [589.7,215.2],
  [596.2,215.2],
  [602.6,215.2],
  [609,215.2],
  [615.4,215.2],
  [621.8,215.2],
  [628.2,215.2],
  [634.6,215.2],
  [641,215.2],
  [653.8,215.2],
  [660.3,215.2],
  [666.7,215.2],
  [673.1,215.2],
  [679.5,215.2],
  [685.9,215.2],
  [692.3,215.2],
  [698.7,215.2],
  [705.1,215.2],
  [711.5,215.2],
  [717.9,215.2],
  [724.4,215.2],
  [730.8,215.2],
  [737.2,215.2],
  [743.6,215.2],
  [750,215.2],
  [756.4,215.2],
  [762.8,215.2],
  [769.2,215.2],
  [775.6,215.2],
  [782.1,215.2],
  [788.5,215.2],
  [794.9,215.2],
  [801.3,215.2],
  [807.7,215.2],
  [814.1,215.2],
  [820.5,215.2],
  [826.9,215.2],
  [833.3,215.2],
  [839.7,215.2],
  [846.2,215.2],
  [852.6,215.2],
  [859,215.2],
  [865.4,215.2],
  [160.3,221.5],
  [173.1,221.5],
  [179.5,221.5],
  [185.9,221.5],
  [192.3,221.5],
  [198.7,221.5],
  [205.1,221.5],
  [256.4,221.5],
  [461.5,221.5],
  [467.9,221.5],
  [474.4,221.5],
  [480.8,221.5],
  [487.2,221.5],
  [493.6,221.5],
  [500,221.5],
  [506.4,221.5],
  [512.8,221.5],
  [519.2,221.5],
  [525.6,221.5],
  [532.1,221.5],
  [538.5,221.5],
  [544.9,221.5],
  [551.3,221.5],
  [557.7,221.5],
  [564.1,221.5],
  [570.5,221.5],
  [576.9,221.5],
  [583.3,221.5],
  [589.7,221.5],
  [596.2,221.5],
  [609,221.5],
  [615.4,221.5],
  [621.8,221.5],
  [628.2,221.5],
  [634.6,221.5],
  [641,221.5],
  [647.4,221.5],
  [666.7,221.5],
  [673.1,221.5],
  [679.5,221.5],
  [685.9,221.5],
  [692.3,221.5],
  [698.7,221.5],
  [705.1,221.5],
  [711.5,221.5],
  [717.9,221.5],
  [724.4,221.5],
  [730.8,221.5],
  [737.2,221.5],
  [743.6,221.5],
  [750,221.5],
  [756.4,221.5],
  [762.8,221.5],
  [769.2,221.5],
  [775.6,221.5],
  [782.1,221.5],
  [788.5,221.5],
  [794.9,221.5],
  [801.3,221.5],
  [807.7,221.5],
  [814.1,221.5],
  [820.5,221.5],
  [826.9,221.5],
  [833.3,221.5],
  [839.7,221.5],
  [846.2,221.5],
  [852.6,221.5],
  [859,221.5],
  [179.5,227.8],
  [185.9,227.8],
  [192.3,227.8],
  [198.7,227.8],
  [205.1,227.8],
  [461.5,227.8],
  [467.9,227.8],
  [474.4,227.8],
  [480.8,227.8],
  [487.2,227.8],
  [493.6,227.8],
  [500,227.8],
  [506.4,227.8],
  [512.8,227.8],
  [519.2,227.8],
  [525.6,227.8],
  [532.1,227.8],
  [538.5,227.8],
  [544.9,227.8],
  [551.3,227.8],
  [557.7,227.8],
  [564.1,227.8],
  [570.5,227.8],
  [576.9,227.8],
  [583.3,227.8],
  [589.7,227.8],
  [596.2,227.8],
  [602.6,227.8],
  [615.4,227.8],
  [621.8,227.8],
  [628.2,227.8],
  [634.6,227.8],
  [641,227.8],
  [647.4,227.8],
  [653.8,227.8],
  [666.7,227.8],
  [705.1,227.8],
  [711.5,227.8],
  [717.9,227.8],
  [724.4,227.8],
  [730.8,227.8],
  [737.2,227.8],
  [743.6,227.8],
  [750,227.8],
  [756.4,227.8],
  [762.8,227.8],
  [769.2,227.8],
  [775.6,227.8],
  [782.1,227.8],
  [788.5,227.8],
  [794.9,227.8],
  [801.3,227.8],
  [807.7,227.8],
  [814.1,227.8],
  [820.5,227.8],
  [826.9,227.8],
  [833.3,227.8],
  [839.7,227.8],
  [846.2,227.8],
  [852.6,227.8],
  [185.9,234.2],
  [192.3,234.2],
  [198.7,234.2],
  [205.1,234.2],
  [256.4,234.2],
  [455.1,234.2],
  [461.5,234.2],
  [467.9,234.2],
  [474.4,234.2],
  [480.8,234.2],
  [487.2,234.2],
  [493.6,234.2],
  [500,234.2],
  [506.4,234.2],
  [512.8,234.2],
  [519.2,234.2],
  [525.6,234.2],
  [532.1,234.2],
  [538.5,234.2],
  [544.9,234.2],
  [551.3,234.2],
  [557.7,234.2],
  [564.1,234.2],
  [570.5,234.2],
  [576.9,234.2],
  [583.3,234.2],
  [589.7,234.2],
  [596.2,234.2],
  [602.6,234.2],
  [621.8,234.2],
  [628.2,234.2],
  [634.6,234.2],
  [641,234.2],
  [647.4,234.2],
  [653.8,234.2],
  [660.3,234.2],
  [666.7,234.2],
  [673.1,234.2],
  [711.5,234.2],
  [717.9,234.2],
  [724.4,234.2],
  [730.8,234.2],
  [737.2,234.2],
  [743.6,234.2],
  [750,234.2],
  [756.4,234.2],
  [762.8,234.2],
  [769.2,234.2],
  [775.6,234.2],
  [782.1,234.2],
  [788.5,234.2],
  [794.9,234.2],
  [801.3,234.2],
  [807.7,234.2],
  [814.1,234.2],
  [820.5,234.2],
  [826.9,234.2],
  [833.3,234.2],
  [839.7,234.2],
  [846.2,234.2],
  [865.4,234.2],
  [185.9,240.5],
  [192.3,240.5],
  [198.7,240.5],
  [205.1,240.5],
  [230.8,240.5],
  [237.2,240.5],
  [269.2,240.5],
  [448.7,240.5],
  [455.1,240.5],
  [461.5,240.5],
  [467.9,240.5],
  [474.4,240.5],
  [480.8,240.5],
  [487.2,240.5],
  [493.6,240.5],
  [500,240.5],
  [506.4,240.5],
  [512.8,240.5],
  [519.2,240.5],
  [525.6,240.5],
  [532.1,240.5],
  [538.5,240.5],
  [544.9,240.5],
  [551.3,240.5],
  [557.7,240.5],
  [564.1,240.5],
  [570.5,240.5],
  [576.9,240.5],
  [583.3,240.5],
  [589.7,240.5],
  [596.2,240.5],
  [602.6,240.5],
  [609,240.5],
  [621.8,240.5],
  [628.2,240.5],
  [634.6,240.5],
  [641,240.5],
  [647.4,240.5],
  [653.8,240.5],
  [660.3,240.5],
  [666.7,240.5],
  [673.1,240.5],
  [724.4,240.5],
  [730.8,240.5],
  [737.2,240.5],
  [743.6,240.5],
  [750,240.5],
  [756.4,240.5],
  [782.1,240.5],
  [788.5,240.5],
  [794.9,240.5],
  [801.3,240.5],
  [807.7,240.5],
  [814.1,240.5],
  [820.5,240.5],
  [833.3,240.5],
  [185.9,246.8],
  [192.3,246.8],
  [198.7,246.8],
  [205.1,246.8],
  [230.8,246.8],
  [282.1,246.8],
  [288.5,246.8],
  [455.1,246.8],
  [461.5,246.8],
  [467.9,246.8],
  [474.4,246.8],
  [480.8,246.8],
  [487.2,246.8],
  [493.6,246.8],
  [500,246.8],
  [506.4,246.8],
  [512.8,246.8],
  [519.2,246.8],
  [525.6,246.8],
  [532.1,246.8],
  [538.5,246.8],
  [544.9,246.8],
  [551.3,246.8],
  [557.7,246.8],
  [564.1,246.8],
  [570.5,246.8],
  [576.9,246.8],
  [583.3,246.8],
  [589.7,246.8],
  [596.2,246.8],
  [602.6,246.8],
  [609,246.8],
  [628.2,246.8],
  [634.6,246.8],
  [641,246.8],
  [647.4,246.8],
  [653.8,246.8],
  [660.3,246.8],
  [666.7,246.8],
  [673.1,246.8],
  [724.4,246.8],
  [730.8,246.8],
  [737.2,246.8],
  [743.6,246.8],
  [750,246.8],
  [788.5,246.8],
  [794.9,246.8],
  [801.3,246.8],
  [807.7,246.8],
  [814.1,246.8],
  [198.7,253.2],
  [205.1,253.2],
  [211.5,253.2],
  [217.9,253.2],
  [224.4,253.2],
  [230.8,253.2],
  [455.1,253.2],
  [461.5,253.2],
  [467.9,253.2],
  [474.4,253.2],
  [480.8,253.2],
  [487.2,253.2],
  [493.6,253.2],
  [500,253.2],
  [506.4,253.2],
  [512.8,253.2],
  [519.2,253.2],
  [525.6,253.2],
  [532.1,253.2],
  [538.5,253.2],
  [544.9,253.2],
  [551.3,253.2],
  [557.7,253.2],
  [564.1,253.2],
  [570.5,253.2],
  [576.9,253.2],
  [583.3,253.2],
  [589.7,253.2],
  [596.2,253.2],
  [602.6,253.2],
  [609,253.2],
  [615.4,253.2],
  [628.2,253.2],
  [634.6,253.2],
  [641,253.2],
  [647.4,253.2],
  [653.8,253.2],
  [660.3,253.2],
  [724.4,253.2],
  [730.8,253.2],
  [737.2,253.2],
  [743.6,253.2],
  [788.5,253.2],
  [794.9,253.2],
  [801.3,253.2],
  [807.7,253.2],
  [814.1,253.2],
  [820.5,253.2],
  [865.4,253.2],
  [224.4,259.5],
  [230.8,259.5],
  [237.2,259.5],
  [243.6,259.5],
  [448.7,259.5],
  [455.1,259.5],
  [461.5,259.5],
  [467.9,259.5],
  [474.4,259.5],
  [480.8,259.5],
  [487.2,259.5],
  [493.6,259.5],
  [500,259.5],
  [506.4,259.5],
  [512.8,259.5],
  [519.2,259.5],
  [525.6,259.5],
  [532.1,259.5],
  [538.5,259.5],
  [544.9,259.5],
  [551.3,259.5],
  [557.7,259.5],
  [564.1,259.5],
  [570.5,259.5],
  [576.9,259.5],
  [583.3,259.5],
  [589.7,259.5],
  [596.2,259.5],
  [602.6,259.5],
  [609,259.5],
  [615.4,259.5],
  [634.6,259.5],
  [641,259.5],
  [647.4,259.5],
  [724.4,259.5],
  [730.8,259.5],
  [737.2,259.5],
  [794.9,259.5],
  [801.3,259.5],
  [807.7,259.5],
  [814.1,259.5],
  [820.5,259.5],
  [826.9,259.5],
  [865.4,259.5],
  [237.2,265.8],
  [243.6,265.8],
  [455.1,265.8],
  [461.5,265.8],
  [467.9,265.8],
  [474.4,265.8],
  [480.8,265.8],
  [487.2,265.8],
  [493.6,265.8],
  [500,265.8],
  [506.4,265.8],
  [512.8,265.8],
  [519.2,265.8],
  [525.6,265.8],
  [532.1,265.8],
  [538.5,265.8],
  [544.9,265.8],
  [551.3,265.8],
  [557.7,265.8],
  [564.1,265.8],
  [570.5,265.8],
  [576.9,265.8],
  [583.3,265.8],
  [589.7,265.8],
  [596.2,265.8],
  [602.6,265.8],
  [609,265.8],
  [615.4,265.8],
  [621.8,265.8],
  [628.2,265.8],
  [634.6,265.8],
  [730.8,265.8],
  [737.2,265.8],
  [801.3,265.8],
  [807.7,265.8],
  [814.1,265.8],
  [820.5,265.8],
  [826.9,265.8],
  [865.4,265.8],
  [243.6,272.2],
  [275.6,272.2],
  [282.1,272.2],
  [288.5,272.2],
  [461.5,272.2],
  [467.9,272.2],
  [474.4,272.2],
  [480.8,272.2],
  [487.2,272.2],
  [493.6,272.2],
  [500,272.2],
  [506.4,272.2],
  [512.8,272.2],
  [519.2,272.2],
  [525.6,272.2],
  [532.1,272.2],
  [538.5,272.2],
  [544.9,272.2],
  [551.3,272.2],
  [557.7,272.2],
  [564.1,272.2],
  [570.5,272.2],
  [576.9,272.2],
  [583.3,272.2],
  [589.7,272.2],
  [596.2,272.2],
  [602.6,272.2],
  [609,272.2],
  [615.4,272.2],
  [621.8,272.2],
  [628.2,272.2],
  [647.4,272.2],
  [653.8,272.2],
  [730.8,272.2],
  [737.2,272.2],
  [814.1,272.2],
  [820.5,272.2],
  [871.8,272.2],
  [250,278.5],
  [256.4,278.5],
  [262.8,278.5],
  [269.2,278.5],
  [275.6,278.5],
  [282.1,278.5],
  [288.5,278.5],
  [294.9,278.5],
  [301.3,278.5],
  [307.7,278.5],
  [314.1,278.5],
  [461.5,278.5],
  [467.9,278.5],
  [474.4,278.5],
  [480.8,278.5],
  [487.2,278.5],
  [493.6,278.5],
  [500,278.5],
  [506.4,278.5],
  [512.8,278.5],
  [519.2,278.5],
  [525.6,278.5],
  [532.1,278.5],
  [538.5,278.5],
  [544.9,278.5],
  [551.3,278.5],
  [557.7,278.5],
  [564.1,278.5],
  [570.5,278.5],
  [576.9,278.5],
  [583.3,278.5],
  [589.7,278.5],
  [596.2,278.5],
  [602.6,278.5],
  [609,278.5],
  [615.4,278.5],
  [621.8,278.5],
  [628.2,278.5],
  [634.6,278.5],
  [641,278.5],
  [647.4,278.5],
  [743.6,278.5],
  [801.3,278.5],
  [878.2,278.5],
  [269.2,284.8],
  [275.6,284.8],
  [282.1,284.8],
  [288.5,284.8],
  [294.9,284.8],
  [301.3,284.8],
  [307.7,284.8],
  [314.1,284.8],
  [320.5,284.8],
  [467.9,284.8],
  [474.4,284.8],
  [480.8,284.8],
  [487.2,284.8],
  [493.6,284.8],
  [500,284.8],
  [506.4,284.8],
  [512.8,284.8],
  [519.2,284.8],
  [525.6,284.8],
  [532.1,284.8],
  [538.5,284.8],
  [544.9,284.8],
  [551.3,284.8],
  [557.7,284.8],
  [564.1,284.8],
  [570.5,284.8],
  [576.9,284.8],
  [583.3,284.8],
  [589.7,284.8],
  [596.2,284.8],
  [602.6,284.8],
  [609,284.8],
  [615.4,284.8],
  [621.8,284.8],
  [628.2,284.8],
  [634.6,284.8],
  [641,284.8],
  [647.4,284.8],
  [743.6,284.8],
  [801.3,284.8],
  [852.6,284.8],
  [269.2,291.1],
  [275.6,291.1],
  [282.1,291.1],
  [288.5,291.1],
  [294.9,291.1],
  [301.3,291.1],
  [307.7,291.1],
  [314.1,291.1],
  [320.5,291.1],
  [326.9,291.1],
  [333.3,291.1],
  [339.7,291.1],
  [519.2,291.1],
  [525.6,291.1],
  [532.1,291.1],
  [538.5,291.1],
  [544.9,291.1],
  [551.3,291.1],
  [557.7,291.1],
  [564.1,291.1],
  [570.5,291.1],
  [576.9,291.1],
  [583.3,291.1],
  [589.7,291.1],
  [596.2,291.1],
  [602.6,291.1],
  [609,291.1],
  [615.4,291.1],
  [621.8,291.1],
  [628.2,291.1],
  [634.6,291.1],
  [641,291.1],
  [794.9,291.1],
  [807.7,291.1],
  [846.2,291.1],
  [852.6,291.1],
  [269.2,297.5],
  [275.6,297.5],
  [282.1,297.5],
  [288.5,297.5],
  [294.9,297.5],
  [301.3,297.5],
  [307.7,297.5],
  [314.1,297.5],
  [320.5,297.5],
  [326.9,297.5],
  [333.3,297.5],
  [339.7,297.5],
  [346.2,297.5],
  [532.1,297.5],
  [538.5,297.5],
  [544.9,297.5],
  [551.3,297.5],
  [557.7,297.5],
  [564.1,297.5],
  [570.5,297.5],
  [576.9,297.5],
  [583.3,297.5],
  [589.7,297.5],
  [596.2,297.5],
  [602.6,297.5],
  [609,297.5],
  [615.4,297.5],
  [621.8,297.5],
  [628.2,297.5],
  [634.6,297.5],
  [794.9,297.5],
  [801.3,297.5],
  [807.7,297.5],
  [839.7,297.5],
  [846.2,297.5],
  [852.6,297.5],
  [262.8,303.8],
  [269.2,303.8],
  [275.6,303.8],
  [282.1,303.8],
  [288.5,303.8],
  [294.9,303.8],
  [301.3,303.8],
  [307.7,303.8],
  [314.1,303.8],
  [320.5,303.8],
  [326.9,303.8],
  [333.3,303.8],
  [339.7,303.8],
  [346.2,303.8],
  [532.1,303.8],
  [538.5,303.8],
  [544.9,303.8],
  [551.3,303.8],
  [557.7,303.8],
  [564.1,303.8],
  [570.5,303.8],
  [576.9,303.8],
  [583.3,303.8],
  [589.7,303.8],
  [596.2,303.8],
  [602.6,303.8],
  [609,303.8],
  [615.4,303.8],
  [621.8,303.8],
  [628.2,303.8],
  [801.3,303.8],
  [807.7,303.8],
  [833.3,303.8],
  [839.7,303.8],
  [846.2,303.8],
  [852.6,303.8],
  [884.6,303.8],
  [262.8,310.1],
  [269.2,310.1],
  [275.6,310.1],
  [282.1,310.1],
  [288.5,310.1],
  [294.9,310.1],
  [301.3,310.1],
  [307.7,310.1],
  [314.1,310.1],
  [320.5,310.1],
  [326.9,310.1],
  [333.3,310.1],
  [339.7,310.1],
  [346.2,310.1],
  [352.6,310.1],
  [359,310.1],
  [365.4,310.1],
  [532.1,310.1],
  [538.5,310.1],
  [544.9,310.1],
  [551.3,310.1],
  [557.7,310.1],
  [564.1,310.1],
  [570.5,310.1],
  [576.9,310.1],
  [583.3,310.1],
  [589.7,310.1],
  [596.2,310.1],
  [602.6,310.1],
  [609,310.1],
  [615.4,310.1],
  [621.8,310.1],
  [807.7,310.1],
  [814.1,310.1],
  [833.3,310.1],
  [839.7,310.1],
  [846.2,310.1],
  [865.4,310.1],
  [903.8,310.1],
  [916.7,310.1],
  [256.4,316.5],
  [262.8,316.5],
  [269.2,316.5],
  [275.6,316.5],
  [282.1,316.5],
  [288.5,316.5],
  [294.9,316.5],
  [301.3,316.5],
  [307.7,316.5],
  [314.1,316.5],
  [320.5,316.5],
  [326.9,316.5],
  [333.3,316.5],
  [339.7,316.5],
  [346.2,316.5],
  [352.6,316.5],
  [359,316.5],
  [365.4,316.5],
  [371.8,316.5],
  [378.2,316.5],
  [384.6,316.5],
  [538.5,316.5],
  [544.9,316.5],
  [551.3,316.5],
  [557.7,316.5],
  [564.1,316.5],
  [570.5,316.5],
  [576.9,316.5],
  [583.3,316.5],
  [589.7,316.5],
  [596.2,316.5],
  [602.6,316.5],
  [609,316.5],
  [615.4,316.5],
  [814.1,316.5],
  [846.2,316.5],
  [910.3,316.5],
  [916.7,316.5],
  [923.1,316.5],
  [929.5,316.5],
  [935.9,316.5],
  [256.4,322.8],
  [262.8,322.8],
  [269.2,322.8],
  [275.6,322.8],
  [282.1,322.8],
  [288.5,322.8],
  [294.9,322.8],
  [301.3,322.8],
  [307.7,322.8],
  [314.1,322.8],
  [320.5,322.8],
  [326.9,322.8],
  [333.3,322.8],
  [339.7,322.8],
  [346.2,322.8],
  [352.6,322.8],
  [359,322.8],
  [365.4,322.8],
  [371.8,322.8],
  [378.2,322.8],
  [384.6,322.8],
  [391,322.8],
  [538.5,322.8],
  [544.9,322.8],
  [551.3,322.8],
  [557.7,322.8],
  [564.1,322.8],
  [570.5,322.8],
  [576.9,322.8],
  [583.3,322.8],
  [589.7,322.8],
  [596.2,322.8],
  [602.6,322.8],
  [609,322.8],
  [615.4,322.8],
  [820.5,322.8],
  [923.1,322.8],
  [929.5,322.8],
  [935.9,322.8],
  [942.3,322.8],
  [967.9,322.8],
  [262.8,329.1],
  [269.2,329.1],
  [275.6,329.1],
  [282.1,329.1],
  [288.5,329.1],
  [294.9,329.1],
  [301.3,329.1],
  [307.7,329.1],
  [314.1,329.1],
  [320.5,329.1],
  [326.9,329.1],
  [333.3,329.1],
  [339.7,329.1],
  [346.2,329.1],
  [352.6,329.1],
  [359,329.1],
  [365.4,329.1],
  [371.8,329.1],
  [378.2,329.1],
  [384.6,329.1],
  [391,329.1],
  [544.9,329.1],
  [551.3,329.1],
  [557.7,329.1],
  [564.1,329.1],
  [570.5,329.1],
  [576.9,329.1],
  [583.3,329.1],
  [589.7,329.1],
  [596.2,329.1],
  [602.6,329.1],
  [609,329.1],
  [615.4,329.1],
  [839.7,329.1],
  [846.2,329.1],
  [916.7,329.1],
  [923.1,329.1],
  [929.5,329.1],
  [942.3,329.1],
  [980.8,329.1],
  [269.2,335.4],
  [275.6,335.4],
  [282.1,335.4],
  [288.5,335.4],
  [294.9,335.4],
  [301.3,335.4],
  [307.7,335.4],
  [314.1,335.4],
  [320.5,335.4],
  [326.9,335.4],
  [333.3,335.4],
  [339.7,335.4],
  [346.2,335.4],
  [352.6,335.4],
  [359,335.4],
  [365.4,335.4],
  [371.8,335.4],
  [378.2,335.4],
  [384.6,335.4],
  [544.9,335.4],
  [551.3,335.4],
  [557.7,335.4],
  [564.1,335.4],
  [570.5,335.4],
  [576.9,335.4],
  [583.3,335.4],
  [589.7,335.4],
  [596.2,335.4],
  [602.6,335.4],
  [609,335.4],
  [615.4,335.4],
  [987.2,335.4],
  [269.2,341.8],
  [275.6,341.8],
  [282.1,341.8],
  [288.5,341.8],
  [294.9,341.8],
  [301.3,341.8],
  [307.7,341.8],
  [314.1,341.8],
  [320.5,341.8],
  [326.9,341.8],
  [333.3,341.8],
  [339.7,341.8],
  [346.2,341.8],
  [352.6,341.8],
  [359,341.8],
  [365.4,341.8],
  [371.8,341.8],
  [378.2,341.8],
  [384.6,341.8],
  [544.9,341.8],
  [551.3,341.8],
  [557.7,341.8],
  [564.1,341.8],
  [570.5,341.8],
  [576.9,341.8],
  [583.3,341.8],
  [589.7,341.8],
  [596.2,341.8],
  [602.6,341.8],
  [609,341.8],
  [615.4,341.8],
  [621.8,341.8],
  [647.4,341.8],
  [897.4,341.8],
  [903.8,341.8],
  [910.3,341.8],
  [929.5,341.8],
  [275.6,348.1],
  [282.1,348.1],
  [288.5,348.1],
  [294.9,348.1],
  [301.3,348.1],
  [307.7,348.1],
  [314.1,348.1],
  [320.5,348.1],
  [326.9,348.1],
  [333.3,348.1],
  [339.7,348.1],
  [346.2,348.1],
  [352.6,348.1],
  [359,348.1],
  [365.4,348.1],
  [371.8,348.1],
  [378.2,348.1],
  [538.5,348.1],
  [544.9,348.1],
  [551.3,348.1],
  [557.7,348.1],
  [564.1,348.1],
  [570.5,348.1],
  [576.9,348.1],
  [583.3,348.1],
  [589.7,348.1],
  [596.2,348.1],
  [602.6,348.1],
  [609,348.1],
  [615.4,348.1],
  [621.8,348.1],
  [647.4,348.1],
  [884.6,348.1],
  [891,348.1],
  [897.4,348.1],
  [903.8,348.1],
  [929.5,348.1],
  [935.9,348.1],
  [282.1,354.4],
  [288.5,354.4],
  [294.9,354.4],
  [301.3,354.4],
  [307.7,354.4],
  [314.1,354.4],
  [320.5,354.4],
  [326.9,354.4],
  [333.3,354.4],
  [339.7,354.4],
  [346.2,354.4],
  [352.6,354.4],
  [359,354.4],
  [365.4,354.4],
  [371.8,354.4],
  [378.2,354.4],
  [538.5,354.4],
  [544.9,354.4],
  [551.3,354.4],
  [557.7,354.4],
  [564.1,354.4],
  [570.5,354.4],
  [576.9,354.4],
  [583.3,354.4],
  [589.7,354.4],
  [596.2,354.4],
  [602.6,354.4],
  [609,354.4],
  [615.4,354.4],
  [634.6,354.4],
  [641,354.4],
  [647.4,354.4],
  [878.2,354.4],
  [884.6,354.4],
  [891,354.4],
  [897.4,354.4],
  [903.8,354.4],
  [910.3,354.4],
  [929.5,354.4],
  [935.9,354.4],
  [288.5,360.8],
  [294.9,360.8],
  [301.3,360.8],
  [307.7,360.8],
  [314.1,360.8],
  [320.5,360.8],
  [326.9,360.8],
  [333.3,360.8],
  [339.7,360.8],
  [346.2,360.8],
  [352.6,360.8],
  [359,360.8],
  [365.4,360.8],
  [371.8,360.8],
  [378.2,360.8],
  [538.5,360.8],
  [544.9,360.8],
  [551.3,360.8],
  [557.7,360.8],
  [564.1,360.8],
  [570.5,360.8],
  [576.9,360.8],
  [583.3,360.8],
  [589.7,360.8],
  [596.2,360.8],
  [602.6,360.8],
  [609,360.8],
  [634.6,360.8],
  [641,360.8],
  [647.4,360.8],
  [871.8,360.8],
  [878.2,360.8],
  [884.6,360.8],
  [891,360.8],
  [897.4,360.8],
  [903.8,360.8],
  [910.3,360.8],
  [916.7,360.8],
  [923.1,360.8],
  [929.5,360.8],
  [935.9,360.8],
  [294.9,367.1],
  [301.3,367.1],
  [307.7,367.1],
  [314.1,367.1],
  [320.5,367.1],
  [326.9,367.1],
  [333.3,367.1],
  [339.7,367.1],
  [346.2,367.1],
  [352.6,367.1],
  [359,367.1],
  [365.4,367.1],
  [371.8,367.1],
  [544.9,367.1],
  [551.3,367.1],
  [557.7,367.1],
  [564.1,367.1],
  [570.5,367.1],
  [576.9,367.1],
  [583.3,367.1],
  [589.7,367.1],
  [596.2,367.1],
  [602.6,367.1],
  [634.6,367.1],
  [641,367.1],
  [859,367.1],
  [865.4,367.1],
  [871.8,367.1],
  [878.2,367.1],
  [884.6,367.1],
  [891,367.1],
  [897.4,367.1],
  [903.8,367.1],
  [910.3,367.1],
  [916.7,367.1],
  [923.1,367.1],
  [929.5,367.1],
  [935.9,367.1],
  [942.3,367.1],
  [288.5,373.4],
  [294.9,373.4],
  [301.3,373.4],
  [307.7,373.4],
  [314.1,373.4],
  [320.5,373.4],
  [326.9,373.4],
  [333.3,373.4],
  [339.7,373.4],
  [346.2,373.4],
  [352.6,373.4],
  [359,373.4],
  [365.4,373.4],
  [371.8,373.4],
  [544.9,373.4],
  [551.3,373.4],
  [557.7,373.4],
  [564.1,373.4],
  [570.5,373.4],
  [576.9,373.4],
  [583.3,373.4],
  [589.7,373.4],
  [596.2,373.4],
  [602.6,373.4],
  [634.6,373.4],
  [641,373.4],
  [846.2,373.4],
  [852.6,373.4],
  [859,373.4],
  [865.4,373.4],
  [871.8,373.4],
  [878.2,373.4],
  [884.6,373.4],
  [891,373.4],
  [897.4,373.4],
  [903.8,373.4],
  [910.3,373.4],
  [916.7,373.4],
  [923.1,373.4],
  [929.5,373.4],
  [935.9,373.4],
  [942.3,373.4],
  [948.7,373.4],
  [288.5,379.7],
  [294.9,379.7],
  [301.3,379.7],
  [307.7,379.7],
  [314.1,379.7],
  [320.5,379.7],
  [326.9,379.7],
  [333.3,379.7],
  [339.7,379.7],
  [346.2,379.7],
  [352.6,379.7],
  [544.9,379.7],
  [551.3,379.7],
  [557.7,379.7],
  [564.1,379.7],
  [570.5,379.7],
  [576.9,379.7],
  [583.3,379.7],
  [589.7,379.7],
  [596.2,379.7],
  [602.6,379.7],
  [634.6,379.7],
  [641,379.7],
  [846.2,379.7],
  [852.6,379.7],
  [859,379.7],
  [865.4,379.7],
  [871.8,379.7],
  [878.2,379.7],
  [884.6,379.7],
  [891,379.7],
  [897.4,379.7],
  [903.8,379.7],
  [910.3,379.7],
  [916.7,379.7],
  [923.1,379.7],
  [929.5,379.7],
  [935.9,379.7],
  [942.3,379.7],
  [948.7,379.7],
  [955.1,379.7],
  [288.5,386.1],
  [294.9,386.1],
  [301.3,386.1],
  [307.7,386.1],
  [314.1,386.1],
  [320.5,386.1],
  [326.9,386.1],
  [333.3,386.1],
  [339.7,386.1],
  [346.2,386.1],
  [352.6,386.1],
  [551.3,386.1],
  [557.7,386.1],
  [564.1,386.1],
  [570.5,386.1],
  [576.9,386.1],
  [583.3,386.1],
  [589.7,386.1],
  [596.2,386.1],
  [846.2,386.1],
  [852.6,386.1],
  [859,386.1],
  [865.4,386.1],
  [871.8,386.1],
  [878.2,386.1],
  [884.6,386.1],
  [891,386.1],
  [897.4,386.1],
  [903.8,386.1],
  [910.3,386.1],
  [916.7,386.1],
  [923.1,386.1],
  [929.5,386.1],
  [935.9,386.1],
  [942.3,386.1],
  [948.7,386.1],
  [955.1,386.1],
  [961.5,386.1],
  [288.5,392.4],
  [294.9,392.4],
  [301.3,392.4],
  [307.7,392.4],
  [314.1,392.4],
  [320.5,392.4],
  [326.9,392.4],
  [333.3,392.4],
  [339.7,392.4],
  [346.2,392.4],
  [352.6,392.4],
  [551.3,392.4],
  [557.7,392.4],
  [564.1,392.4],
  [570.5,392.4],
  [576.9,392.4],
  [583.3,392.4],
  [589.7,392.4],
  [596.2,392.4],
  [846.2,392.4],
  [852.6,392.4],
  [859,392.4],
  [865.4,392.4],
  [871.8,392.4],
  [878.2,392.4],
  [884.6,392.4],
  [891,392.4],
  [897.4,392.4],
  [903.8,392.4],
  [910.3,392.4],
  [916.7,392.4],
  [923.1,392.4],
  [929.5,392.4],
  [935.9,392.4],
  [942.3,392.4],
  [948.7,392.4],
  [955.1,392.4],
  [961.5,392.4],
  [288.5,398.7],
  [294.9,398.7],
  [301.3,398.7],
  [307.7,398.7],
  [314.1,398.7],
  [320.5,398.7],
  [326.9,398.7],
  [333.3,398.7],
  [339.7,398.7],
  [346.2,398.7],
  [557.7,398.7],
  [564.1,398.7],
  [570.5,398.7],
  [576.9,398.7],
  [583.3,398.7],
  [589.7,398.7],
  [852.6,398.7],
  [859,398.7],
  [865.4,398.7],
  [871.8,398.7],
  [878.2,398.7],
  [884.6,398.7],
  [891,398.7],
  [897.4,398.7],
  [903.8,398.7],
  [910.3,398.7],
  [916.7,398.7],
  [923.1,398.7],
  [929.5,398.7],
  [935.9,398.7],
  [942.3,398.7],
  [948.7,398.7],
  [955.1,398.7],
  [288.5,405.1],
  [294.9,405.1],
  [301.3,405.1],
  [307.7,405.1],
  [314.1,405.1],
  [320.5,405.1],
  [326.9,405.1],
  [333.3,405.1],
  [339.7,405.1],
  [557.7,405.1],
  [564.1,405.1],
  [570.5,405.1],
  [576.9,405.1],
  [583.3,405.1],
  [852.6,405.1],
  [859,405.1],
  [865.4,405.1],
  [871.8,405.1],
  [878.2,405.1],
  [884.6,405.1],
  [903.8,405.1],
  [910.3,405.1],
  [916.7,405.1],
  [923.1,405.1],
  [929.5,405.1],
  [935.9,405.1],
  [942.3,405.1],
  [948.7,405.1],
  [955.1,405.1],
  [288.5,411.4],
  [294.9,411.4],
  [301.3,411.4],
  [307.7,411.4],
  [314.1,411.4],
  [320.5,411.4],
  [326.9,411.4],
  [333.3,411.4],
  [557.7,411.4],
  [564.1,411.4],
  [570.5,411.4],
  [576.9,411.4],
  [852.6,411.4],
  [859,411.4],
  [865.4,411.4],
  [871.8,411.4],
  [910.3,411.4],
  [916.7,411.4],
  [923.1,411.4],
  [929.5,411.4],
  [935.9,411.4],
  [942.3,411.4],
  [948.7,411.4],
  [955.1,411.4],
  [282.1,417.7],
  [288.5,417.7],
  [294.9,417.7],
  [301.3,417.7],
  [307.7,417.7],
  [314.1,417.7],
  [320.5,417.7],
  [326.9,417.7],
  [916.7,417.7],
  [923.1,417.7],
  [929.5,417.7],
  [935.9,417.7],
  [942.3,417.7],
  [948.7,417.7],
  [282.1,424.1],
  [288.5,424.1],
  [294.9,424.1],
  [301.3,424.1],
  [307.7,424.1],
  [314.1,424.1],
  [320.5,424.1],
  [326.9,424.1],
  [923.1,424.1],
  [929.5,424.1],
  [935.9,424.1],
  [942.3,424.1],
  [948.7,424.1],
  [282.1,430.4],
  [288.5,430.4],
  [294.9,430.4],
  [301.3,430.4],
  [307.7,430.4],
  [282.1,436.7],
  [288.5,436.7],
  [294.9,436.7],
  [301.3,436.7],
  [307.7,436.7],
  [282.1,443],
  [288.5,443],
  [294.9,443],
  [301.3,443],
  [307.7,443],
  [942.3,443],
  [282.1,449.4],
  [288.5,449.4],
  [294.9,449.4],
  [301.3,449.4],
  [275.6,455.7],
  [282.1,455.7],
  [288.5,455.7],
  [294.9,455.7],
  [275.6,462],
  [282.1,462],
  [288.5,462],
  [294.9,462],
  [275.6,468.4],
  [282.1,468.4],
  [288.5,468.4],
  [294.9,468.4],
  [275.6,474.7],
  [282.1,474.7],
  [288.5,474.7],
  [294.9,474.7],
  [711.5,474.7],
  [275.6,481],
  [282.1,481],
  [288.5,481],
  [275.6,487.3],
  [282.1,487.3],
  [288.5,487.3],
  [282.1,493.7],
  [288.5,493.7],
  [294.9,493.7],
  [288.5,500],
  [294.9,500],
  [301.3,500]
];

// City positions (mapped from dotted-map coordinates)
export const LONDON: [number, number] = [500, 126.6];
export const SINGAPORE: [number, number] = [814.1, 297.5];
export const SYDNEY: [number, number] = [955.1, 411.4];
